import React, { useState, useEffect, useRef, useCallback } from "react";
import CustomCardSlider from "../../Components/CardSlider/card-slider";
import "swiper/css";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { useSelector, useDispatch } from "react-redux";
import {
  changeRequestDotTrue,
  changeRequestDotFalse,
} from "../../Redux/store/requestDots";
import {
  changeDeletedAccountFalse,
  AddClientIdAccountFalse,
  UpdateUAStatusFalse,
  changeUpdatedAccountFalse,
} from "../../Redux/store/selectedAccountDeleted";
import { changeArchivedAccountFalse } from "../../Redux/store/selectedAccountArchieved";
import DropdownTest from "../../Pages/Create-Investment/ndrop";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { debounce } from "lodash";
import DocumentPreview from "../Create-Investment/documentpreview";
import { currentAppUrl } from "../../Constants/config";
import {
  changeCardTrue,
  changeCardFalse,
  changeCustomerTabTrue,
} from "../../Redux/store/selectedCard";
import countriesData from "../../Data/CountryCodes.json";
import AddressAutocomplete from "../../Components/addressInput/address-input";
import CustomDropdownWithFetch from "../../Components/CustomDropdown/custom-dropdown-fetchAPI";
import PermissionSection from "../../Components/Permissions/permission-section";
import PermissionSectionDisabled from "../../Components/Permissions/permission-section-disabled";
import { setCustomerNameRedux } from "../../Redux/store/userSlice";
import { useRoutingNumberValidation } from "../../Components/bank-validations/use-routing-number-validation";

const validator = require("validator");

const CustomerDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);
  const location = useLocation();
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const dispatch = useDispatch();
  const buttonRefs = useRef({});
  const roleName = useSelector((state) => state.user.roleName);
  const customerName = useSelector((state) => state.user.customerName);
  const { from, componentName, advisorId } = location.state || {};
  const [error, setError] = useState("");
  const [countries, setCountries] = useState([]);
  const StatusRef = useRef();
  const [mobileNumber, setMobileNumber] = useState("");
  const [focus, setFocus] = useState(false);
  const [selectedCode, setSelectedCode] = useState("");
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef();
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const cardActivated = useSelector((state) => state.cards.cardExisted);
  const customerTab = useSelector((state) => state.cards.customerTab);
  const dotMenuOpened = useSelector((state) => state.request.requestDot);
  const accountDeleted = useSelector(
    (state) => state.deletedAccount.deletedAccount
  );
  const accountUpdated = useSelector(
    (state) => state.deletedAccount.updatedAccount
  );
  const addClientIdAccount = useSelector(
    (state) => state.deletedAccount.addClientIdAccount
  );
  const [swiftError, setSwiftError] = useState("");

  const [totalPendingExternalBank, setTotalPendingExternalBank] = useState(0);

  const updateUAStatus = useSelector(
    (state) => state.deletedAccount.updateUAStatus
  );
  const accountArchieved = useSelector(
    (state) => state.archivedAccount.archivedAccount
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [totalCount, settotalCount] = useState(0);
  const [transactionTableData, setTransactionTableData] = useState([]);
  const [showRecords, setShowRecords] = useState(10);
  const [transactionRemarksId, setTransactionRemarksId] = useState(null);
  const [status, setStatus] = useState("");
  const [transactionRemarksStatus, setTransactionRemarksStatus] =
    useState(null);
  const [thirdPartyFilterTab, setThirdPartyFilterTab] = useState("allThp");
  const userId = useSelector((state) => state.user.userId);

  const [loading, setLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [currentDocument, setcurrentDocument] = useState({});
  const [currentBank, setcurrentBank] = useState({});
  const [isModalOpenBankEdit, setIsModalOpenBankEdit] = useState(false);
  const [isModalOpenProfileEdit, setIsModalOpenProfileEdit] = useState(false);
  const [hinNumber, sethinNumber] = useState("");
  const [hinClientId, sethinClientId] = useState("");
  const [newFirstName, setNewFirstName] = useState("");
  const [newLastName, setNewLastName] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [isOpenEditHIN, setisOpenEditHIN] = useState(false);
  const [swiftCode, setSwiftCode] = useState("");
  const [transitNumber, setTransitNumber] = useState("");
  const [institutionNumber, setinstitutionNumber] = useState("");
  const [iban, setIban] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [newCity, setNewCity] = useState("");
  const [newState, setNewState] = useState("");
  const [newAddress, setNewAddress] = useState("");
  const [newZipCode, setNewZipCode] = useState("");
  const [bankTab, setBankTab] = useState("");
  const [totalCountExternalBank, setTotalCountExternalBank] = useState(0);
  const [totalPagesExternalBank, setTotalPagesExternalBank] = useState(0);
  const [currentPageExternalBank, setCurrentPageExternalBank] = useState(1);
  const [externalbankTable, setExternalbankTable] = useState([]);
  const [totalPendingBank, setTotalPendingBank] = useState(0);
  const { routingNumber, routingError, handleRoutingChange, setRoutingNumber } =
    useRoutingNumberValidation();
  const [showRecordsExternalBank, setShowRecordsExternalBank] = useState(10);
  const [isOpenEditCashAccountBank, setIsOpenEditCashAccountBank] =
    useState(false);
  const [transitError, setTransitError] = useState("");
  const [bsbError, setBsbError] = useState("");
  const externalAccountHeaders = [
    { label: "Date", key: "" },
    { label: "Account Name", key: "" },
    { label: "Account Number/IBAN", key: "" },
    { label: "Account BSB", key: "" },
    { label: "Bank Name", key: "" },
    { label: "Other Details", key: "" },
    { label: "Bank Address", key: "" },
    { label: "Country Code", key: "" },
    { label: "Status", key: "" },
    { label: "Action", key: "" },
  ];
  const tabs = [
    { id: "extBank", label: "External Bank" },
    { id: "thpBank", label: "Third Party Bank" },
  ];
  const AllStatusExternal = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];
  const validateSwift = (value) => {
    const swiftRegex =
      /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    return swiftRegex.test(value);
  };
  const handleSwiftChange = (e) => {
    const value = e.target.value.toUpperCase(); // optional: auto uppercase
    setSwiftCode(value);

    if (value && !validateSwift(value)) {
      setSwiftError("Invalid SWIFT/BIC format");
    } else {
      setSwiftError("");
    }
  };
  const handleStatusChangeBank = useCallback(
    debounce(async (e, option, rowId) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateRequestStatusCallBank(option, rowId);
        if (response.status == 200) {
          toastMessage = {
            message: "Request completed successfully",
            type: "success",
          };
          getAllBanksDataAdmin();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        handleDropdownToggleExternalbank(null);
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [] // Dependencies
  );
  const handleDropdownToggleExternalbank = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const resetAllThpFilters = () => {
    setShowRecordsExternalBank(10);
    setCurrentPageExternalBank(1);
  };
  const getAllBanksDataAdmin = async () => {
    try {
      setIsLoading(true);
      // Determine the base path based on role
      const basePath =
        loggedInUserRole === "advisor"
          ? `/v1/advisor/account/external-bank/list/external`
          : `/v1/account/external-bank/list/external`;

      // Build query params
      const params = new URLSearchParams({
        user_id: customerId,
        limit: showRecordsExternalBank,
        page: currentPageExternalBank,
      });

      // Add status param if selected
      if (selectedStatus) {
        params.append("status", selectedStatus);
      }
      const response = await GetAPIcalls(`${basePath}?${params.toString()}`);
      if (
        response.status == 200 &&
        response.data &&
        response.data.bank_accounts.length > 0
      ) {
        setExternalbankTable(response.data.bank_accounts);
        setTotalPagesExternalBank(response.data.total_pages);
        setCurrentPageExternalBank(response.data.page);
        setTotalCountExternalBank(response.data.total_count);
        setTotalPendingExternalBank(response.data.pending_count);
      } else {
        setExternalbankTable([]);
        setTotalPagesExternalBank(0);
        setCurrentPageExternalBank(1);
        setTotalCountExternalBank(0);
      }
    } catch (err) {
      setExternalbankTable([]);
      setTotalPagesExternalBank(0);
      setCurrentPageExternalBank(1);
      setTotalCountExternalBank(0);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const UpdateRequestStatusCallBank = async (optionValue, rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };
    const apiUrl =
      optionValue.value == "approved"
        ? `${BASE_URL}/v1/account/external-bank/approve/${rowId}`
        : `${BASE_URL}/v1/account/external-bank/reject/${rowId}`;
    const bodyData = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleshowRecordBank = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsExternalBank(parseInt(selectedOption.value));
    setCurrentPageExternalBank(1);
  };
  const europeanCountryCodes = new Set([
    "AL",
    "AD",
    "AM",
    "AT",
    "AZ",
    "BY",
    "BE",
    "BA",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "GE",
    "DE",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "KZ",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "MD",
    "MC",
    "ME",
    "NL",
    "MK",
    "NO",
    "PL",
    "PT",
    "RO",
    "RU",
    "SM",
    "RS",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "TR",
    "UA",
    "GB",
    "VA",
  ]);
  const handleAddressSelect = (place) => {
    console.log("Selected Address:", place);
    console.log("State:", place.address.state);
    console.log("Zipcode:", place.address.postcode);
  };
  // Step 2: Function to check if a code is European
  function isEuropeanCountry(code) {
    return europeanCountryCodes.has(code.toUpperCase());
  }
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  function setCountryCodeEdit(countryCode) {
    const match = countryCodeData.find((c) => c.value === countryCode);
    if (match) {
      setpreselectedCountryCode({
        value: match.value,
        label: match.label,
      });
    } else {
      // Optional: set a default if no match found
      setpreselectedCountryCode({
        value: "",
        label: "",
      });
    }
  }
  const handleEditClick = (e, rowData) => {
    setcurrentBank(rowData.id);
    setIsModalOpenBankEdit(true);

    setToAccountName(rowData.account_name);
    if (rowData.country_code == null) {
      setCountryCode("AU");
      setCountryCodeEdit("AU");
    } else {
      setCountryCode(rowData.country_code);
      setCountryCodeEdit(rowData.country_code);
    }
    setToAccountNumber(rowData.account_number);
    setToBank(rowData.bank_name);

    if (rowData.currency == null) {
      setpreselectedCurrency({
        value: 2,
        label: "AUD",
      });
      setToCurrency(2);
    } else {
      setpreselectedCurrency({
        value: rowData.currency.id,
        label: rowData.currency.name,
      });
      setToCurrency(rowData.currency.id);
    }

    setToBsb(rowData.account_bsb);
    setSwiftCode(rowData.swift_code);
    setRoutingNumber(rowData.routing_number);
    setTransitNumber(rowData.transit_number);
    setinstitutionNumber(rowData.institution_number);
    setIban(rowData.iban);
    setAddressLine1(rowData.address_line1);
    setAddressLine2(rowData.address_line2);
    setAddressLine3(rowData.address_line3);
  };
  const handleBsbChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setToBsb(numericValue);

    // Validation: must be 6 digits
    if (numericValue.length === 0) {
      setBsbError("BSB is required");
    } else if (numericValue.length !== 6) {
      setBsbError("BSB must be 6 digits");
    } else {
      setBsbError("");
    }
  };
  const handleTransitChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setTransitNumber(numericValue);

    // Validation: must be 5 digits
    if (numericValue.length === 0) {
      setTransitError("Transit number is required");
    } else if (numericValue.length !== 5) {
      setTransitError("Transit number must be 5 digits");
    } else {
      setTransitError("");
    }
  };
  const handleEditClickProfile = () => {
    setIsModalOpenProfileEdit(true);
    setNewFirstName(profileData.first_name);
    setNewLastName(profileData.last_name);
    setNewEmail(profileData.email_address);
    setMobileNumber(profileData.mobile_number);
    setSelectedCode(profileData.country_code);
    if (addressData.country != null) {
      setpreselectedCountryCodeProfile({
        value: addressData.country.id,
        label: addressData.country.name,
      });
      setCountryCodeProfile(addressData.country.id);
    }
    if (addressData.city != null) {
      setpreselectedCity({
        value: addressData.city.id,
        label: addressData.city.name,
      });
      setNewCity(addressData.city.id);
    }

    if (addressData.state != null) {
      setpreselectedState({
        value: addressData.state.id,
        label: addressData.state.name,
      });
      setNewState(addressData.state.id);
    }
    setNewZipCode(addressData.zip_code);
    setNewAddress(addressData.google_address);
  };
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const AllStatus = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];
  const AllStatusFilters = [
    { value: null, label: "ALL" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
  ];
  const handleSelectStatus = async (option) => {
    setSelectedStatus(option.value);
    setIsStatusOpen(false);
    setCurrentPage(1);
    setCurrentPageExternalBank(1);
  };
  const handleStatusChange = useCallback(
    debounce(async (e, option, rowId) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateRequestStatusCall(option, rowId);
        if (response.status == 200) {
          toastMessage = {
            message: "Request completed successfully",
            type: "success",
          };
          getBankData();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [] // Dependencies
  );
  const togglePopupEdit = () => {
    setisOpenEdit(!isOpenEdit);
    setcurrentPassword("");
    setnewPassword("");
    setconfirmPassword("");
    setShowConfirmPassword(false);
    setShowCurrentPassword(false);
    setShowNewPassword(false);
  };
  const togglePopupEditHIN = () => {
    setisOpenEditHIN(!isOpenEditHIN);
    sethinClientId("");
    sethinNumber("");
  };
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState("");
  const [showcurrentPassword, setShowCurrentPassword] = useState(false);
  const [currentpassword, setcurrentPassword] = useState("");
  const [shownewPassword, setShowNewPassword] = useState(false);
  const [newPassword, setnewPassword] = useState("");
  const [isNewChangeFees, setisNewChangeFees] = useState(true);
  const [profileData, setprofileData] = useState({});
  const [accountAnalytics, setAccountAnalytics] = useState({});
  const [addressData, setAddressData] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [defaultCard, setDefaultCard] = useState({});
  const searchParams = new URLSearchParams(location.search);
  const cardId = searchParams.get("cardId");
  const { customerId } = useParams();
  const { customerPrevId } = useParams();
  const [filter, setFilter] = useState(cardId ? "accounts" : customerTab);
  const [isOpenEditCashAccount, setisOpenEditCashAccount] = useState(false);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine3, setAddressLine3] = useState("");
  const [toBsb, setToBsb] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [countryCode, setCountryCode] = useState("AU");
  const [countryCodeProfile, setCountryCodeProfile] = useState("");
  const [toAccountName, setToAccountName] = useState("");
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: "AU",
    label: "Australia",
  });
  const [preselectedCountryCodeProfile, setpreselectedCountryCodeProfile] =
    useState({});
  const [preselectedCity, setpreselectedCity] = useState({});
  const [preselectedState, setpreselectedState] = useState({});

  const [toAccountNumber, setToAccountNumber] = useState("");
  const [toBank, setToBank] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [chunks, setChunks] = useState([]);
  const [bankdata, setBankdata] = useState([
    {
      id: 0,
      bank_name: "Test",
      account_name: "Dummmy",
      account_number: null,
      bsb: null,
      swift: "082-356",
      branch_address: "333 George St, Sydney NSW 2000 Australia",
      currency: "AUD",
    },
  ]);
  const [accountdata, setAccountData] = useState({
    no_of_active_accounts: 0,
    no_of_archieved_accounts: 0,
    active_accounts: {
      my_investments: 0,
    },
    archieved_accounts: {},
  });
  useEffect(() => {
    if (Object.keys(permissions).length > 0) {
      const sectionEntries = Object.entries(permissions);
      const chunkSize = 3;
      const newChunks = [];

      for (let i = 0; i < sectionEntries.length; i += chunkSize) {
        newChunks.push(sectionEntries.slice(i, i + chunkSize));
      }
      setChunks(newChunks);
    }
  }, [permissions]);
  const getAllUserPermissions = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(`/v1/permissions/user/${customerId}`);

      if (response.status == 200) {
        setPermissions(response.data.permissions);
      } else {
        if (response.status === 400) {
          setPermissions([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setPermissions([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const getAllAdviorUserPermissions = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/permissions/advisors/${advisorId}/customers/${customerId}/permissions`
      );

      if (response.status == 200) {
        setPermissions(response.data.permissions);
      } else {
        if (response.status === 400) {
          setPermissions([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setPermissions([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const getAllSubAdviorUserPermissions = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/permissions/sub-advisors/${advisorId}/customers/${customerId}/permissions`
      );

      if (response.status == 200) {
        setPermissions(response.data.permissions);
      } else {
        if (response.status === 400) {
          setPermissions([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setPermissions([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const buildPayload = () => {
    let payload = [];

    // Loop through each section (account, bank, etc.)
    Object.values(permissions).forEach((section) => {
      section.forEach((perm) => {
        payload.push({
          unique_id: perm.unique_id,
          allowed: perm.status, // status → allowed
          // valid_from: "2020-05-01",   // optional
          // valid_until: "2026-06-01"  // optional
        });
      });
    });

    return payload;
  };
  const updatePermission = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/permissions/user/update`;

    const bodyData = {
      user_id: customerId,
      permissions: buildPayload(),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUpdatePermissions = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updatePermission();
        if (response.status == 200) {
          getAllUserPermissions();
          toastMessage = {
            message: "Details updated successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [customerId, permissions] // Dependencies
  );
  const updatePermissionAdvisor = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/permissions/advisors/${advisorId}/customers/${customerId}/permissions/update`;

    const bodyData = {
      permissions: buildPayload(),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUpdatePermissionsAdvisor = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updatePermissionAdvisor();
        if (response.status == 200) {
          if (componentName == "advisor") {
            getAllAdviorUserPermissions();
          }
          if (componentName == "sub-advisor") {
            getAllSubAdviorUserPermissions();
          }
          toastMessage = {
            message: "Details updated successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [customerId, permissions, advisorId] // Dependencies
  );
  const withOutheadersRequestDashboard = [
    { label: "Date", key: "" },
    { label: "Account Name", key: "" },
    { label: "Account Number/IBAN", key: "" },
    { label: "Account BSB", key: "" },
    { label: "Bank Name", key: "" },
    { label: "Other Details", key: "" },
    { label: "Bank Address", key: "" },
    { label: "Country Code", key: "" },
    { label: "Status", key: "" },
    { label: "Document", key: "" },
    { label: "Action", key: "" },
  ];
  const [cardDatanew, setcardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [countryData, setCountryData] = useState([]);

  const customerTypeData = [
    {
      value: 1,
      label: "Individual",
    },
    {
      value: 2,
      label: "Corporate",
    },
  ];

  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode(selectedOption.value);
  };
  const handleSelectCountryCodeProfile = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCodeProfile(selectedOption.value);
    setStateData([]);
    setCityData([]);
    setpreselectedCity({});
    setpreselectedState({});
  };
  const handleSelectCity = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setNewCity(selectedOption.value);
    setpreselectedCity(selectedOption);
  };
  const handleSelectState = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setNewState(selectedOption.value);
    setpreselectedState(selectedOption);
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const addBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/account/external-bank/add`;
    const bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber.replace(/\s+/g, ""),
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      user_id: customerId,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban.replace(/\s+/g, ""),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const togglePopupAddBankCashAccount = () => {
    clearAllFieldsBank();
    setIsOpenEditCashAccountBank(!isOpenEditCashAccountBank);
  };
  const addThpBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let bodyData = {};
    let apiUrl = `${BASE_URL}/v1/account/external-bank/add/external`;
    bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber.replace(/\s+/g, ""),
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban.replace(/\s+/g, ""),
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleThirdPartyBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addThpBank();
        if (response.status == 201) {
          setisOpenEditCashAccount(false);
          setisOpenEdit(false);
          setIsOpenEditCashAccountBank(false);
          getAllBanksDataAdmin();
          toastMessage = {
            message: "Bank added successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      customerId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ] // Dependencies
  );
  const handleAddBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addBank();
        if (response.status == 201) {
          setisOpenEditCashAccount(false);
          setisOpenEdit(false);
          getBankData();

          toastMessage = {
            message:
              "Bank added successfully. Please check your authenticator app to verify the request and proceed",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      customerId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ] // Dependencies
  );
  const handleEditClickBank = (e, rowData) => {
    setcurrentBank(rowData.id);
    setIsModalOpenBankEdit(true);

    setToAccountName(rowData.account_name);
    if (rowData.country_code == null) {
      setCountryCode("AU");
      setCountryCodeEdit("AU");
    } else {
      setCountryCode(rowData.country_code);
      setCountryCodeEdit(rowData.country_code);
    }
    setToAccountNumber(rowData.account_number);
    setToBank(rowData.bank_name);

    if (rowData.currency == null) {
      setpreselectedCurrency({
        value: 2,
        label: "AUD",
      });
      setToCurrency(2);
    } else {
      setpreselectedCurrency({
        value: rowData.currency.id,
        label: rowData.currency.name,
      });
      setToCurrency(rowData.currency.id);
    }

    setToBsb(rowData.account_bsb);
    setSwiftCode(rowData.swift_code);
    setRoutingNumber(rowData.routing_number);
    setTransitNumber(rowData.transit_number);
    setinstitutionNumber(rowData.institution_number);
    setIban(rowData.iban);
    setAddressLine1(rowData.address_line1);
    setAddressLine2(rowData.address_line2);
    setAddressLine3(rowData.address_line3);
  };
  const editBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/account/external-bank/update/${currentBank}`;
    const bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber.replace(/\s+/g, ""),
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      user_id: customerId,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban.replace(/\s+/g, ""),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleEditBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editBank();
        if (response.status == 200) {
          setcurrentBank(null);
          setIsModalOpenBankEdit(false);

          if (bankTab == "extBank") {
            getBankData();
          }
          if (bankTab == "thpBank") {
            getAllBanksDataAdmin();
          }

          toastMessage = {
            message: "Bank edited successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      currentBank,
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      customerId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ] // Dependencies
  );
  const editProfile = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/profile/update/${customerId}`;
    const bodyData = {
      first_name: newFirstName,
      last_name: newLastName,
      country_code: selectedCode,
      mobile_number: mobileNumber,
      email_address: newEmail,
      type: customerType,
      address: {
        city_id: newCity,
        country_id: countryCodeProfile,
        state_id: newState,
        zip_code: newZipCode,
        google_address: newAddress,
      },
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleEditProfile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editProfile();
        if (response.status == 200) {
          setIsModalOpenProfileEdit(false);
          getprofileData();
          toastMessage = {
            message: "Details updated successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      newFirstName,
      newLastName,
      selectedCode,
      mobileNumber,
      newEmail,
      customerType,
      newCity,
      countryCodeProfile,
      newState,
      newZipCode,
      newAddress,
    ] // Dependencies
  );
  const getAllCountryCode = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/country-codes`);

      if (response.status == 200) {
        let AllAccount = [];
        Object.entries(response.data).forEach(([key, value]) => {
          AllAccount.push({
            value: key,
            label: value,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryCodeData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/countries?size=1000`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setCountryData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const getCities = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/cities/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`
      );

      if (response.status === 200) {
        const items = response.data.cities.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.cities.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };
  const getStates = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/states/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`
      );

      if (response.status === 200) {
        const items = response.data.states.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.states.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleDropdownToggle = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };
  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
  };
  const toggleCurrentPassword = () => {
    setShowCurrentPassword((prevState) => !prevState);
  };
  const toggleNewPassword = () => {
    setShowNewPassword((prevState) => !prevState);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const GetAPIcallsPrev = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${url}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getprofileData = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/dashboard/customer/${customerId}?currency=${cardCurrencyName.label}`
          : `/v1/dashboard/customer/${customerId}?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setprofileData(response.data.my_profile);
        setAccountAnalytics(response.data.portfolio);
        setAddressData(response.data.address);
        dispatch(
          setCustomerNameRedux(
            response.data.my_profile.first_name +
              " " +
              response.data.my_profile.last_name
          )
        );
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setprofileData({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );

      if (isOutside) {
        setOpenDropdown(null); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);

    const pad = (num) => String(num).padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year}`;
  };
  const getBankData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        selectedStatus == null
          ? `/v1/account/external-bank/list?user_id=${customerId}&limit=${showRecords}&page=${currentPage}`
          : `/v1/account/external-bank/list?user_id=${customerId}&limit=${showRecords}&status=${selectedStatus}&page=${currentPage}`
      );

      if (response.status == 200) {
        setTransactionTableData(response.data.banks);
        settotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total);
        setTotalPendingBank(response.data.pending_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setBankdata([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getAccountData = async () => {
    setAccountData({
      no_of_active_accounts: 0,
      no_of_archieved_accounts: 0,
      active_accounts: {
        my_investments: 0,
      },
      archieved_accounts: {},
    });
    try {
      const response = await GetAPIcalls(
        `/v1/dashboard/customer/accounts/${customerId}`
      );

      if (response.status == 200) {
        setAccountData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAccountData({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleToggle = (section, id) => {
    setPermissions((prev) => ({
      ...prev,
      [section]: prev[section].map((perm) =>
        perm.unique_id === id ? { ...perm, status: !perm.status } : perm
      ),
    }));
  };
  const clearAllFieldsBank = () => {
    setToAccountName("");
    setpreselectedCurrency({ value: 2, label: "AUD" });
    setpreselectedCountryCode({ value: "AU", label: "Australia" });
    setAddressLine1("");
    setToAccountNumber("");
    setToBank("");
    setAddressLine2("");
    setToBsb("");
    setCountryCode("AU");
    setToCurrency(2);
    setAddressLine3("");
    setSwiftCode("");
    setRoutingNumber("");
    setTransitNumber("");
    setIban("");
    setinstitutionNumber("");
  };
  const togglePopupAddTransactionCashAccount = () => {
    clearAllFieldsBank();
    setisOpenEditCashAccount(!isOpenEditCashAccount);
  };
  const handleChangeIban = (e) => {
    const value = e.target.value.toUpperCase(); // IBANs are uppercase
    setIban(value);
  };
  const getCardData = async () => {
    setIsLoading(true);
    try {
      if (filter == "accounts") {
        const response = await GetAPIcalls(
          `/v1/dashboard/customer/stats/${customerId}?currency=${cardCurrencyName.label}`
        );

        if (response.status == 200) {
          // const responseCurrentSystem = await GetAPIcallsPrev(
          //   `${currentAppUrl}/api/customer-account-balance?user_id=${customerPrevId}`
          // );
          let responseCurrentSystem = {
            status: "success",
            data: {
              accounts: {
                "Cash Account": 0,
                "Fund Management": 0,
                Securities: 0,
                "Trading Account": 0,
                "Private Wealth": 0,
                Custodian: 0,
                "My Investment - SMA": 0,
                "Digital Assets ": 0,
              },
            },
          };
          if (responseCurrentSystem.status == "success") {
            // if (response.status == 200) {
            const cardData = [
              {
                label: "Cash Account",
                id: "1",
                amount: response.data?.cash_account.total_cash_account_balance
                  ? response.data.cash_account.total_cash_account_balance.toFixed(
                      2
                    )
                  : "0.00",
                accounts: response.data.cash_account.cash_accounts,
                customerId: customerId,
                isLocked: false,
                color: "bg-[#5D88F8] bg-opacity-70",
                lessColor: "bg-[#5D88F8] bg-opacity-40",
                tail: "border-t-[#5D88F8] border-b-[#5D88F8]  border-opacity-70",
              },
              {
                label: "Private Wealth Account",
                id: "2",
                amount: response.data?.private_wealth_account
                  .total_private_wealth_account_balance
                  ? response.data.private_wealth_account.total_private_wealth_account_balance.toFixed(
                      2
                    )
                  : "0.00",
                accounts:
                  response.data.private_wealth_account.private_wealth_accounts,
                customerId: customerId,
                isLocked: false,
                color: "bg-[#996EE7] bg-opacity-70",
                lessColor: "bg-[#996EE7] bg-opacity-40",
                tail: "border-t-[#996EE7] border-opacity-70",
              },
              {
                label: "Securities",
                id: "3",
                amount:
                  responseCurrentSystem.data.accounts.Securities != "inactive"
                    ? responseCurrentSystem.data.accounts.Securities.toFixed(2)
                    : "0.00",
                isLocked:
                  responseCurrentSystem.data.accounts.Securities == "inactive"
                    ? true
                    : false,

                accounts: response.data.total_securities.securities,
                customerId: customerId,
                color: "bg-[#F18C29] bg-opacity-70",
                lessColor: "bg-[#F18C29] bg-opacity-40",
                tail: "border-t-[#F18C29] border-opacity-70",
              },
              {
                label: "Fund Management",
                id: "4",
                amount:
                  responseCurrentSystem.data.accounts["Fund Management"] !=
                  "inactive"
                    ? responseCurrentSystem.data.accounts[
                        "Fund Management"
                      ].toFixed(2)
                    : "0.00",
                isLocked:
                  responseCurrentSystem.data.accounts["Fund Management"] ==
                  "inactive"
                    ? true
                    : false,
                accounts: response.data.total_tradings.total_tradings,
                customerId: customerId,
                color: "bg-[#DC4646] bg-opacity-70",
                lessColor: "bg-[#DC4646] bg-opacity-40",
                tail: "border-t-[#DC4646] border-opacity-70",
              },
              {
                label: "Custodian",
                id: "5",
                amount:
                  responseCurrentSystem.data.accounts.Custodian != "inactive"
                    ? responseCurrentSystem.data.accounts.Custodian.toFixed(2)
                    : "0.00",
                isLocked:
                  responseCurrentSystem.data.accounts.Custodian == "inactive"
                    ? true
                    : false,
                accounts: response.data.total_tradings.tradings,
                customerId: customerId,
                color: "bg-[#2DB0EC] bg-opacity-70",
                lessColor: "bg-[#2DB0EC] bg-opacity-40",
                tail: "border-t-[#2DB0EC] border-opacity-70",
              },
              {
                label: "Private Wealth (Commodities)",
                id: "6",
                amount:
                  responseCurrentSystem.data.accounts["Private Wealth"] !=
                  "inactive"
                    ? responseCurrentSystem.data.accounts[
                        "Private Wealth"
                      ].toFixed(2)
                    : "0.00",
                isLocked:
                  responseCurrentSystem.data.accounts["Private Wealth"] ==
                  "inactive"
                    ? true
                    : false,
                accounts: response.data.total_fund_management.fund_management,
                customerId: customerId,
                color: "bg-[#6B68F2] bg-opacity-70",
                lessColor: "bg-[#6B68F2] bg-opacity-40",
                tail: "border-t-[#6B68F2] border-opacity-70",
              },
              {
                label: "Digital Assets",
                id: "7",
                amount:
                  responseCurrentSystem.data.accounts["Digital Assets "] !=
                  "inactive"
                    ? responseCurrentSystem.data.accounts[
                        "Digital Assets "
                      ].toFixed(2)
                    : "0.00",
                accounts: response.data.digital_assets.digital_assets,
                isLocked:
                  responseCurrentSystem.data.accounts["Digital Assets "] ==
                  "inactive"
                    ? true
                    : false,
                customerId: customerId,
                lessColor: "bg-[#34C046] bg-opacity-70",
                color: "bg-[#34C046] bg-opacity-40",
                tail: "border-t-[#34C046] border-opacity-70",
              },
              {
                label: "My Investment",
                id: "8",
                amount:
                  responseCurrentSystem.data.accounts["My Investment - SMA"] !=
                  "inactive"
                    ? responseCurrentSystem.data.accounts[
                        "My Investment - SMA"
                      ].toFixed(2)
                    : "0.00",
                isLocked:
                  responseCurrentSystem.data.accounts["My Investment - SMA"] ==
                  "inactive"
                    ? true
                    : false,
                accounts: response.data.digital_assets.digital_assets,
                customerId: customerId,
                lessColor: "bg-[#0F172A] bg-opacity-70",
                color: "bg-[#0F172A] bg-opacity-40",
                tail: "border-t-[#0F172A] border-opacity-70",
              },
            ];
            setcardData(cardData);
            const defaultCard = cardData.find(
              (card) => card.id === cardActivated
            );
            if (cardId) {
              setDefaultCard(cardData[cardId]);
            } else {
              setDefaultCard(defaultCard || cardData[0]);
            }
            dispatch(changeDeletedAccountFalse());
            dispatch(changeUpdatedAccountFalse());
            dispatch(changeArchivedAccountFalse());
            dispatch(AddClientIdAccountFalse());
            dispatch(UpdateUAStatusFalse());
          } else {
            const cardData = [
              {
                label: "Cash Account",
                id: "1",
                amount: response.data?.cash_account.total_cash_account_balance
                  ? response.data.cash_account.total_cash_account_balance.toFixed(
                      2
                    )
                  : "0.00",
                accounts: response.data.cash_account.cash_accounts,
                customerId: customerId,
                color: "bg-[#5D88F8] bg-opacity-70",
                lessColor: "bg-[#5D88F8] bg-opacity-40",
                tail: "border-t-[#5D88F8] border-b-[#5D88F8]  border-opacity-70",
              },
              {
                label: "Private Wealth Account",
                id: "2",
                amount: response.data?.private_wealth_account
                  .total_private_wealth_account_balance
                  ? response.data.private_wealth_account.total_private_wealth_account_balance.toFixed(
                      2
                    )
                  : "0.00",
                accounts:
                  response.data.private_wealth_account.private_wealth_accounts,
                customerId: customerId,
                color: "bg-[#996EE7] bg-opacity-70",
                lessColor: "bg-[#996EE7] bg-opacity-40",
                tail: "border-t-[#996EE7] border-opacity-70",
              },
              {
                label: "Securities",
                id: "3",
                amount: "0.00",
                accounts: response.data.total_securities.securities,
                customerId: customerId,
                color: "bg-[#F18C29] bg-opacity-70",
                lessColor: "bg-[#F18C29] bg-opacity-40",
                tail: "border-t-[#F18C29] border-opacity-70",
              },
              {
                label: "Fund Management",
                id: "4",
                amount: "0.00",
                accounts: response.data.total_tradings.total_tradings,
                customerId: customerId,
                color: "bg-[#DC4646] bg-opacity-70",
                lessColor: "bg-[#DC4646] bg-opacity-40",
                tail: "border-t-[#DC4646] border-opacity-70",
              },
              {
                label: "Custodian",
                id: "5",
                amount: "0.00",
                accounts: response.data.total_tradings.tradings,
                customerId: customerId,
                color: "bg-[#2DB0EC] bg-opacity-70",
                lessColor: "bg-[#2DB0EC] bg-opacity-40",
                tail: "border-t-[#2DB0EC] border-opacity-70",
              },
              {
                label: "Private Wealth (Commodities)",
                id: "6",
                amount: "0.00",
                accounts: response.data.total_fund_management.fund_management,
                customerId: customerId,
                color: "bg-[#6B68F2] bg-opacity-70",
                lessColor: "bg-[#6B68F2] bg-opacity-40",
                tail: "border-t-[#6B68F2] border-opacity-70",
              },
              {
                label: "Digital Assets",
                id: "7",
                amount: "0.00",
                accounts: response.data.digital_assets.digital_assets,
                customerId: customerId,
                lessColor: "bg-[#34C046] bg-opacity-70",
                color: "bg-[#34C046] bg-opacity-40",
                tail: "border-t-[#34C046] border-opacity-70",
              },
              {
                label: "My Investment",
                id: "8",
                amount: "0.00",
                accounts: response.data.digital_assets.digital_assets,
                customerId: customerId,
                lessColor: "bg-[#0F172A] bg-opacity-70",
                color: "bg-[#0F172A] bg-opacity-40",
                tail: "border-t-[#0F172A] border-opacity-70",
              },
            ];
            setcardData(cardData);
            const defaultCard = cardData.find(
              (card) => card.id === cardActivated
            );
            if (cardId) {
              setDefaultCard(cardData[cardId]);
            } else {
              setDefaultCard(defaultCard || cardData[0]);
            }
            dispatch(changeDeletedAccountFalse());
            dispatch(changeArchivedAccountFalse());
            dispatch(AddClientIdAccountFalse());
            dispatch(UpdateUAStatusFalse());
            showToast(response.message, "error");
          }
        } else {
          if (response.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          if (response.status === 400) {
            setcardData([]);
            setDefaultCard({});
            showToast(response.message, "error");
          }
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setDefaultCard({});
    } finally {
      if (filter == "accounts") {
        setTimeout(function () {
          setIsLoading(false);
        }, 100);
      } else {
        setTimeout(function () {
          setIsLoading(false);
        }, 600);
      }
    }
  };
  useEffect(() => {
    if (filter === "profile") {
      getprofileData();
      getAllCountries();
    }
    if (filter === "banks") {
      getAllCountryCode();
      getAllCurrency();
    }
    if (filter === "permissions") {
      if (componentName == "customer") {
        getAllUserPermissions();
      }
      if (componentName == "advisor") {
        getAllAdviorUserPermissions();
      }
      if (componentName == "sub-advisor") {
        getAllSubAdviorUserPermissions();
      }
    }
  }, [filter, componentName, advisorId, cardCurrencyName]);
  useEffect(() => {
    if (filter === "banks") {
      if (bankTab == "extBank") {
        getBankData();
      }
      if (bankTab == "thpBank") {
        getAllBanksDataAdmin();
      }
    }
  }, [
    filter,
    bankTab,
    showRecords,
    selectedStatus,
    currentPage,
    customerId,
    showRecordsExternalBank,
    currentPageExternalBank,
  ]);
  useEffect(() => {
    getCardData();
  }, [filter, customerId, cardCurrencyName]);
  // useEffect(() => {
  //   if (cardActivated == false) {
  //     getAccountData();
  //   }
  // }, [cardActivated]);
  useEffect(() => {
    if (
      accountDeleted == true ||
      accountArchieved == true ||
      updateUAStatus == true ||
      addClientIdAccount == true ||
      accountUpdated == true
    ) {
      // getAccountData();
      getCardData();
    }
  }, [
    accountDeleted,
    accountArchieved,
    addClientIdAccount,
    updateUAStatus,
    accountUpdated,
  ]);
  const UpdatePassword = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/dashboard/change-password/${customerId}`;
    const bodyData = {
      old_password: currentpassword,
      new_password: newPassword,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };

  const handleshowRecord = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const handleUpdatePassword = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await UpdatePassword();

        if (response.status == 200) {
          togglePopupEdit();
          toastMessage = {
            message: "Password Updated successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [currentpassword, newPassword, confirmPassword] // Dependencies
  );
  const UpdateHinNumber = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/user/add-bd-details/${customerId}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      bd_client_id: hinClientId,
      bd_hin_number: hinNumber,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUpdateHinNumber = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await UpdateHinNumber();

        if (response.status == 200) {
          togglePopupEditHIN();
          getprofileData();
          toastMessage = {
            message: "Client ID and HIN number updated successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [hinNumber, hinClientId, customerId] // Dependencies
  );
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const handleScroll = (indexToRemove) => {
    console.log("I an scroll in customer");
    if (dotMenuOpened) {
      dispatch(changeRequestDotFalse());
    }
  };
  useEffect(() => {
    if (dotMenuOpened) {
      console.log("Dropdown for create opened, adding scroll event listener.");
      window.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      console.log(
        "Dropdown for create closed, removing scroll event listener."
      );
      window.removeEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [dotMenuOpened]);
  const UpdateRequestStatusCall = async (optionValue, rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };
    const apiUrl =
      optionValue.value == "approved"
        ? `${BASE_URL}/v1/account/external-bank/approve/${rowId}`
        : `${BASE_URL}/v1/account/external-bank/reject/${rowId}`;
    const bodyData = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  return (
    <div onScroll={handleScroll} className="w-full  pt-4">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="pt-4 text-xs overflow-x-auto flex flex-wrap items-center justify-between">
        {/* Left buttons */}
        <div className="flex mb-2">
          <button
            onClick={() => {
              setFilter("profile");
              dispatch(changeCustomerTabTrue("profile"));
            }}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === "profile"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Profile
          </button>
          <button
            onClick={() => {
              setFilter("permissions");
              dispatch(changeCustomerTabTrue("permissions"));
            }}
            className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
              filter === "permissions"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Permissions
          </button>
          <button
            onClick={() => {
              setFilter("banks");
              setBankTab("extBank");
              dispatch(changeCustomerTabTrue("banks"));
            }}
            className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
              filter === "banks" ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            Banks
          </button>
          <button
            onClick={() => {
              dispatch(changeCardFalse());
              dispatch(changeCustomerTabTrue("accounts"));
              setFilter("accounts");
            }}
            className={`px-4 py-2 rounded-r-xl ${
              filter === "accounts"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Accounts
          </button>
        </div>

        {/* Right aligned name */}
        <span className="font-medium  mb-2 bg-white text-[16px] shadow-md px-4 py-2 rounded-xl whitespace-nowrap">
          <p className="">
            <span className="font-medium text-labelLightColour">
              Customer Name:{" "}
            </span>
            <span className="font-medium text-black">{customerName}</span>
          </p>
        </span>
      </div>

      {/* Summary Cards */}
      {filter !== "banks" && isLoading ? (
        <div className="shimmer-container-list mb-4 ">
          {/* Creating 5 rows of shimmer effect */}
          {[...Array(2)].map((_, rowIndex) => (
            <div key={rowIndex} className="shimmer-row-list">
              {/* Creating 7 cells in each row for shimmer */}
              {[...Array(2)].map((_, colIndex) => (
                <div key={colIndex} className="shimmer-cell-list h-20">
                  <div className="shimmer-loader"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div>
          {filter === "accounts" && (
            <CustomCardSlider
              componentName="customer-details"
              cardData={cardDatanew}
              defaultCard={defaultCard}
              ondefaultCard={(value) => setDefaultCard(value)}
            />
          )}
        </div>
      )}

      {filter == "profile" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            {/* Header Section */}
            <div className="flex w-full  flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <img
                  src="/profile-circle-black.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">Profile</span>
              </div>
              <p className="text-sm">
                <span className="font-medium text-labelLightColour">
                  Member since:{" "}
                </span>
                <span className="font-medium text-black">
                  {formatDateTime(profileData.created_at)}
                </span>
                {loggedInUserRole == "super_admin" && (
                  <button
                    onClick={() => handleEditClickProfile()}
                    className="  right-4 px-3 rounded-md text-sm transition-colors duration-200"
                  >
                    <img
                      src="/edit-details.svg" // Replace with the actual path to your edit icon
                      alt="Edit Icon"
                      className="w-4 h-4 cursor-pointer"
                    />
                  </button>
                )}
              </p>
            </div>
            {isModalOpenProfileEdit && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                  {/* Modal Header */}
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Edit Personal Details
                      </h2>
                      <div className="flex justify-end">
                        <img
                          onClick={() => {
                            setIsModalOpenProfileEdit(false);
                          }}
                          src="/add.svg"
                          alt="Add"
                          className="w-10 h-10 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="grid px-4 grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        {/* Code */}
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            First Name
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newFirstName}
                            onChange={(e) => setNewFirstName(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Last Name
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newLastName}
                            onChange={(e) => setNewLastName(e.target.value)}
                            className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Doe"
                          />
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l border-gray-300 px-4">
                        <div className="mb-4">
                          <label
                            htmlFor="mobileNumber"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Mobile Number
                          </label>
                          <div className="flex  items-center">
                            <select
                              value={selectedCode}
                              onChange={handleCodeChange}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              className={` text-code font-medium input-field-mobilecode rounded-md px-2  ${
                                focus
                                  ? "border-black border-2"
                                  : "border-gray-300 border"
                              } border-r-0 leading-tight focus:outline-none `}
                              placeholder="AU+61"
                            >
                              {countries.map((country) => (
                                <option
                                  key={country.code}
                                  value={country.dialCode}
                                >
                                  {country.code} {country.dialCode}
                                </option>
                              ))}
                            </select>
                            <input
                              type="tel"
                              id="mobileNumber"
                              value={mobileNumber}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              onChange={(e) => setMobileNumber(e.target.value)}
                              placeholder="Mobile Number"
                              className={`border  text-black text-base font-medium input-field-mobile px-2 ${
                                focus
                                  ? "border-black border-2"
                                  : "border-gray-300 border"
                              } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Email
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Your Email"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                      <h1 className="text-md font-medium mb-2 text-center">
                        Location Details
                      </h1>
                    </div>{" "}
                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        <div className="">
                          <Dropdown
                            label="Select Country"
                            options={countryData}
                            search={true}
                            preselectedValue={preselectedCountryCodeProfile}
                            onSelect={handleSelectCountryCodeProfile}
                            colorLabel=""
                          />
                        </div>
                        <div>
                          <CustomDropdownWithFetch
                            label="Select City"
                            options={cityData}
                            search={true}
                            preselectedValue={preselectedCity}
                            onSelect={handleSelectCity}
                            colorLabel=""
                            fetchOptions={getCities} // <-- pass fetch function, not options
                          />
                          {/* <input
                            id="finInstituition"
                            type="text"
                            value={newCity}
                            onChange={(e) => setNewCity(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Sydney..."
                          /> */}
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <div>
                          <CustomDropdownWithFetch
                            label="Select State"
                            options={stateData}
                            search={true}
                            preselectedValue={preselectedState}
                            onSelect={handleSelectState}
                            colorLabel=""
                            fetchOptions={getStates} // <-- pass fetch function, not options
                          />
                          {/* <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            State
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newState}
                            onChange={(e) => setNewState(e.target.value)}
                            className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="NSW"
                          /> */}
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Zip Code
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newZipCode}
                            onChange={(e) => setNewZipCode(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Apartment unit 2 etc..."
                          />
                        </div>
                      </div>

                      {/* Right Column */}
                      <div className="space-y-4 px-4 pt-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Address
                          </label>{" "}
                          <textarea
                            id="finInstituition"
                            type="text"
                            value={newAddress}
                            onChange={(e) => setNewAddress(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Apartment unit 2 etc..."
                          />
                          {/* <AddressAutocomplete onSelect={(addr) => setSelectedAddress(addr)} />

      {selectedAddress && (
        <div className="mt-4 p-4 border rounded">
          <p><strong>Full:</strong> {selectedAddress.full}</p>
          <p><strong>Street:</strong> {selectedAddress.street}</p>
          <p><strong>City:</strong> {selectedAddress.city}</p>
          <p><strong>State:</strong> {selectedAddress.state}</p>
          <p><strong>ZIP:</strong> {selectedAddress.zip}</p>
          <p><strong>Country:</strong> {selectedAddress.country}</p>
        </div>
      )} */}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                      <button
                        onClick={() => {
                          setIsModalOpenProfileEdit(false);
                        }}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (!validateEmail(newEmail)) {
                            showToast("Enter the valid email", "error");
                            return;
                          }
                          if (
                            !validator.isMobilePhone(
                              selectedCode + mobileNumber,
                              "any"
                            )
                          ) {
                            console.log("country code " + selectedCode);
                            console.log("mobile number is " + mobileNumber);
                            console.log(
                              validator.isMobilePhone(
                                selectedCode + mobileNumber,
                                "any"
                              )
                            );
                            showToast(
                              "Please enter valid mobile number",
                              "error"
                            );
                            return;
                          }
                          if (
                            !newFirstName ||
                            !newLastName ||
                            !newEmail ||
                            !selectedCode ||
                            !mobileNumber ||
                            !newCity ||
                            !newState ||
                            !newZipCode ||
                            !newAddress ||
                            !countryCodeProfile
                          ) {
                            showToast("Please Add all fields", "error");
                            return;
                          }
                          setLoading(true);
                          handleEditProfile(e);
                        }}
                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                      >
                        Update Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Profile Section */}
            <div className="flex w-full flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
              {/* Profile Picture */}
              <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                <img
                  src="/avatar.svg"
                  alt={`${profileData.first_name}`}
                  className="w-20 h-20 rounded-full object-cover"
                />
                {profileData.status == "active" && (
                  <div className="absolute top-2 left-16 w-3 h-3 bg-[#75E380] rounded-full"></div>
                )}
                {profileData.status == "rejected" && (
                  <div className="absolute top-2 left-16 w-3 h-3 bg-[#FF5050] rounded-full"></div>
                )}
                <label htmlFor="investmentManagerFees" className="mt-2 text-xs">
                  <span className="text-[#A6A6A6]">Client No:</span>
                </label>
                <p className="text-black text-sm">{profileData.client_id}</p>
              </div>

              {/* Profile Details */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                {/* Column 1 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-xs text-[#A6A6A6]"
                  >
                    Status
                  </label>
                  <span className="text-sm">{profileData.status}</span>
                  {profileData.type !== "Corporate" && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          First Name
                        </label>
                        <div className="text-sm">{profileData.first_name}</div>
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Last Name
                        </label>
                        <div className="text-sm">{profileData.last_name}</div>
                      </div>
                    </>
                  )}
                  {profileData.type === "Corporate" && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Company Name
                        </label>
                        <div className="text-sm">
                          {profileData.first_name} {profileData.last_name}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Column 2 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 text-xs"
                  >
                    <span className="text-[#A6A6A6]">Phone</span>
                  </label>
                  <div className="text-sm">
                    {profileData.country_code}
                    {profileData.mobile_number}
                  </div>
                  {profileData.type !== "Corporate" && (
                    <>
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                      >
                        Email
                      </label>
                      <span className="text-sm break-words">
                        {profileData.email_address}
                      </span>
                    </>
                  )}
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                  >
                    Type
                  </label>
                  <div className="text-sm">{profileData.type}</div>
                </div>

                {/* Column 3 */}
                {profileData.type !== "Corporate" && (
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs"
                    >
                      <span className="text-[#A6A6A6]">Password</span>
                    </label>
                    <div className="text-sm">{profileData.password}</div>
                    {loggedInUserRole == "super_admin" && (
                      <button
                        onClick={togglePopupEdit}
                        className="mt-4 py-3 w-40 bg-black text-white text-sm rounded-md hover:bg-gray-800"
                      >
                        Change Password
                      </button>
                    )}
                  </div>
                )}
                {/* column4  */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 text-xs"
                  >
                    <span className="text-[#A6A6A6]">Client ID</span>
                  </label>
                  <div className="text-sm">
                    {profileData.bd_client_id == null
                      ? "Client ID not found"
                      : profileData.bd_client_id}
                  </div>
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 text-xs"
                  >
                    <span className="text-[#A6A6A6]">HIN Number</span>
                  </label>
                  <div className="text-sm">
                    {profileData.bd_hin_number == null
                      ? "HIN Number not found"
                      : profileData.bd_hin_number}
                  </div>
                  {loggedInUserRole == "super_admin" && (
                    <button
                      onClick={togglePopupEditHIN}
                      className="mt-4 py-3 w-40 bg-black text-white text-sm rounded-md hover:bg-gray-800"
                    >
                      Add HIN Number
                    </button>
                  )}
                </div>
                {isOpenEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[700px] p-6">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Change Password
                        </h2>
                        <button onClick={togglePopupEdit}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <div className="grid grid-cols-1 gap-6 items-center">
                        <div className="space-y-4 mx-auto ">
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              Current password
                            </label>
                            <input
                              type={showcurrentPassword ? "text" : "password"}
                              value={currentpassword}
                              required={true}
                              id="currentpassword"
                              onChange={(e) =>
                                setcurrentPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleCurrentPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {showcurrentPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              New password
                            </label>
                            <input
                              type={shownewPassword ? "text" : "password"}
                              value={newPassword}
                              required={true}
                              id="newpassword"
                              onChange={(e) => setnewPassword(e.target.value)}
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleNewPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {shownewPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                            >
                              Repeat password
                            </label>
                            <input
                              type={showconfirmPassword ? "text" : "password"}
                              value={confirmPassword}
                              required={true}
                              id="confirmpassword"
                              onChange={(e) =>
                                setconfirmPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleConfirmPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {showconfirmPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Modal Footer */}
                      <div className="flex justify-center space-x-4 mt-6">
                        <button
                          onClick={togglePopupEdit}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (newPassword.length < 8) {
                              showToast(
                                "Password must have At least 8 characters",
                                "error"
                              );
                              return;
                            }
                            if (!/(?=.*[0-9])/.test(newPassword)) {
                              showToast(
                                "Password must have At least 1 number",
                                "error"
                              );
                              return;
                            }
                            if (
                              !/(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                                newPassword
                              )
                            ) {
                              showToast(
                                "Password must have At least 1 special character",
                                "error"
                              );
                              return;
                            }
                            if (
                              !(
                                /(?=.*[a-z])/.test(newPassword) &&
                                /(?=.*[A-Z])/.test(newPassword)
                              )
                            ) {
                              showToast(
                                "Password must have Both upper and lower case characters",
                                "error"
                              );
                              return;
                            }
                            if (newPassword !== confirmPassword) {
                              showToast(
                                "Confirm password should be same as password",
                                "error"
                              );
                              return;
                            }
                            if (newPassword === currentpassword) {
                              showToast(
                                "New password should be different from current password",
                                "error"
                              );
                              return;
                            }
                            setLoading(true);

                            handleUpdatePassword(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {isOpenEditHIN && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[500px] p-6">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Add HIN Number
                        </h2>
                        <button onClick={togglePopupEditHIN}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <div className="grid grid-cols-1 gap-6 items-center">
                        <div className="space-y-4 mx-auto ">
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              Enter Client ID
                            </label>
                            <input
                              type="text"
                              value={hinClientId}
                              required={true}
                              id="currentpassword"
                              onChange={(e) => sethinClientId(e.target.value)}
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Client Id"
                            />
                            <label
                              htmlFor="password"
                              className="block mt-4 text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              Enter HIN Number
                            </label>
                            <input
                              type="text"
                              value={hinNumber}
                              required={true}
                              id="currentpassword"
                              onChange={(e) => sethinNumber(e.target.value)}
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="HIN Number"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Modal Footer */}
                      <div className="flex justify-center space-x-4 mt-6">
                        <button
                          onClick={togglePopupEditHIN}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (!hinClientId) {
                              showToast("Please enter client ID", "error");
                              return;
                            }
                            if (!hinNumber) {
                              showToast("Please enter HIN Number", "error");
                              return;
                            }
                            setLoading(true);
                            handleUpdateHinNumber(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="pt-4  lg:flex mb-4 lg:space-x-4 gap-4">
            {/* Left Section: Two Cards */}
            <div className="flex flex-col flex-[1.5] space-y-4">
              {/* Total Deposit Card */}
              <div className="bg-white p-6 rounded-lg shadow-lg w-full flex-1">
                <div className="flex justify-between border-b  items-start">
                  <div className="flex items-center pb-2 space-x-4">
                    <img
                      src="/folder-2.svg"
                      alt="Account Icon"
                      className="w-5 h-5"
                    />
                    <h3 className="text-black text-lg font-medium">
                      Accounts Analytics
                    </h3>
                  </div>
                </div>
                {accountAnalytics && (
                  <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-0 sm:gap-6">
                    <div className="text-sm text-gray-500 flex-1  sm:border-b-0 md:border-r sm:border-r-0 border-gray-300 pr-4 pt-4">
                      <div className="mb-4">
                        <p className="text-xs text-[#A6A6A6] mb-1">Portfolio</p>
                        <div className="font-medium text-black">
                          {cardCurrencyName.symbol}
                          {accountAnalytics?.total_portfolio
                            ? accountAnalytics.total_portfolio.toFixed(2)
                            : "0.00"}
                        </div>
                      </div>
                      <div className="mb-4">
                        <p className="text-xs text-[#A6A6A6] mb-1">Accounts</p>
                        <div className="font-medium text-black">
                          {accountAnalytics.no_of_cash_accounts}
                        </div>
                      </div>
                      <div>
                        <p className="text-xs text-[#A6A6A6] mb-1">Deposit</p>
                        <div className="font-medium text-black">
                          {cardCurrencyName.symbol}
                          {accountAnalytics?.total_deposit
                            ? accountAnalytics.total_deposit.toFixed(2)
                            : "0.00"}
                        </div>
                      </div>
                    </div>

                    {/* Withdrawal Section */}
                    <div className="text-sm text-gray-500 flex-1 pr-4 pt-4 flex sm:items-start">
                      <div className="self-start">
                        <p className="text-xs text-[#A6A6A6] mb-1">
                          Withdrawal
                        </p>
                        <div className="font-medium text-black">
                          {cardCurrencyName.symbol}
                          {accountAnalytics?.total_withdrawal
                            ? accountAnalytics.total_withdrawal.toFixed(2)
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Right Section: Account Balance */}
            <div className="bg-white p-6 rounded-lg shadow-lg w-full lg:flex-[1.5] lg:mt-0 mt-4  border border-gray-200 flex-1">
              <div className="flex justify-between border-b  items-start">
                <div className="flex items-center pb-2 space-x-4">
                  <img
                    src="/map.svg"
                    alt="Account Icon"
                    className="w-5 h-5 rounded-full"
                  />
                  <h3 className="text-black text-lg font-medium">Location</h3>
                </div>
              </div>
              {addressData != null && (
                <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-0 sm:gap-6">
                  <div className="text-sm text-gray-500 flex-1  sm:border-b-0 md:border-r sm:border-r-0 border-gray-300 pr-4 pt-4">
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6] mb-1">Country</p>
                      <div className="font-medium text-black">
                        {addressData.country != null
                          ? addressData.country.name
                          : ""}
                      </div>
                    </div>
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6] mb-1">Zip Code</p>
                      <div className="font-medium text-black">
                        {addressData.zip_code}
                      </div>
                    </div>
                    <div>
                      <p className="text-xs text-[#A6A6A6] mb-1">State</p>
                      <div className="font-medium text-black">
                        {addressData.state != null
                          ? addressData.state.name
                          : ""}
                      </div>
                    </div>
                  </div>

                  {/* Withdrawal Section */}
                  <div className="text-sm text-gray-500 flex-1 pr-4 pt-4">
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6]">Address</p>
                      <div className="font-medium text-black">
                        {addressData.google_address}
                      </div>
                    </div>
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6]">City</p>
                      <div className="font-medium text-black">
                        {addressData.city != null ? addressData.city.name : ""}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {filter == "permissions" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            {/* Header */}
            <div className="flex w-full flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-200">
              <div className="flex items-center mb-2 md:mb-0">
                {/* Shield Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="black"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path d="M12 1l9 4v6c0 5-3.8 9.7-9 11-5.2-1.3-9-6-9-11V5l9-4zm-1 14.6l5.3-5.3-1.4-1.4L11 12.8l-1.9-1.9-1.4 1.4 3.3 3.3z" />
                </svg>
                <span className="font-semibold lg:text-xl text-base ml-2">
                  Permissions
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full ">
              {chunks.map((chunk, idx) => (
                <div
                  key={idx}
                  className="flex flex-col md:pl-4 md:pt-2 md:border-l"
                >
                  {chunk.map(([sectionName, sectionPerms]) => (
                    <>
                      {roleName == "super_admin" && (
                        <PermissionSection
                          key={sectionName}
                          title={
                            sectionName.charAt(0).toUpperCase() +
                            sectionName.slice(1).replace("_", " ")
                          }
                          permissions={sectionPerms}
                          onToggle={handleToggle}
                        />
                      )}
                      {roleName != "super_admin" && (
                        <PermissionSectionDisabled
                          key={sectionName}
                          title={
                            sectionName.charAt(0).toUpperCase() +
                            sectionName.slice(1).replace("_", " ")
                          }
                          permissions={sectionPerms}
                          onToggle={handleToggle}
                        />
                      )}
                    </>
                  ))}
                </div>
              ))}
            </div>
          </div>
          {roleName == "super_admin" && (
            <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
              {/* Right Section: Download Button */}
              <div className="flex flex-col md:flex-row items-center justify-end w-full mr-10 space-y-2 md:space-y-0 md:space-x-4">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    if (componentName == "customer") {
                      getAllUserPermissions();
                    }
                    if (componentName == "advisor") {
                      getAllAdviorUserPermissions();
                    }
                    if (componentName == "sub-advisor") {
                      getAllSubAdviorUserPermissions();
                    }
                  }}
                  className="flex w-full md:w-auto items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
                >
                  <span>Undo Changes</span>
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    if (componentName == "customer") {
                      handleUpdatePermissions(e);
                    }
                    if (
                      componentName == "advisor" ||
                      componentName == "sub-advisor"
                    ) {
                      handleUpdatePermissionsAdvisor(e);
                    }
                  }}
                  className="flex w-full md:w-auto items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
                >
                  <span>Save Changes</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {filter == "banks" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="relative w-full border-b border-gray-200 mb-2">
            <div className="flex justify-start space-x-6 md:space-x-10 text-sm md:text-base font-medium">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => {
                    setShowRecords(10);
                    setSelectedStatus(null);
                    setCurrentPage(1);
                    setShowRecordsExternalBank(10);
                    setCurrentPageExternalBank(1);
                    setBankTab(tab.id);
                    setThirdPartyFilterTab("allThp");
                    setSelectedStatus(null);
                    resetAllThpFilters();
                  }}
                  className={`relative pb-3 transition-colors duration-300 ${
                    bankTab === tab.id
                      ? "text-black"
                      : "text-gray-500 hover:text-black"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Animated underline */}
            <div
              className={`absolute bottom-0 h-[2px] bg-black transition-all duration-300 ease-in-out`}
              style={{
                width: bankTab === "extBank" ? "120px" : "160px", // match label width
                transform:
                  bankTab === "extBank"
                    ? "translateX(0%)"
                    : "translateX(140px)", // adjust based on spacing
              }}
            />
          </div>

          {bankTab === "extBank" && (
            <>
            {loggedInUserRole == "super_admin" &&   <div className="pt-2 text-xs overflow-x-auto flex-wrap items-center">
                <div className="flex mb-2 relative">
                  <button
                    onClick={() => {
                      setThirdPartyFilterTab("allThp");
                      setSelectedStatus(null);
                      resetAllThpFilters();
                    }}
                    className={`px-4 py-2 rounded-l-xl border-r border-gray-100 ${
                      thirdPartyFilterTab === "allThp"
                        ? "bg-black text-white"
                        : "bg-white text-black"
                    }`}
                  >
                    All Linked External Bank Accounts
                  </button>

                  <div className="relative">
                    <button
                      onClick={() => {
                        setThirdPartyFilterTab("reqThp");
                        setSelectedStatus("pending");
                        resetAllThpFilters();
                      }}
                      className={`lg:px-4 px-2 py-2 rounded-r-xl relative ${
                        thirdPartyFilterTab === "reqThp"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      Requests
                      {totalPendingBank > 0 && (
                        <span className="absolute -top-2 right-0  -right-2 bg-red-500 text-white text-[10px] text-xs font-bold px-1.5 lg:px-2 py-0.5 rounded-full flex items-center justify-center min-w-[16px] lg:min-w-[18px]">
                          {totalPendingBank > 99 ? "99+" : totalPendingBank}
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
}
              <div className="w-full p-4 bg-white rounded-lg shadow-lg">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b pb-5 border-gray-100">
                  {/* Left: Title */}
                  <div className="flex items-center">
                    <img
                      src="/cards.svg"
                      alt="Company Logo"
                      className="mr-2 w-6 h-6"
                    />
                    <span className="font-medium lg:text-xl text-sm">
                      Linked External Bank Accounts
                    </span>
                  </div>

                  {/* Right: Count and Button  */}
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full md:w-auto justify-end">
                    <p className="text-sm">
                      <span className="font-medium text-labelLightColour">
                        No of Bank Accounts:{" "}
                      </span>
                      <span className="font-medium text-black">
                        {totalCount}
                      </span>
                    </p>
                    <button
                      onClick={togglePopupAddTransactionCashAccount}
                      className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                    >
                      <img
                        src="/Plus.svg"
                        alt="Add Icon"
                        className="mr-2 ml-2"
                      />
                      <span className="inline">Add Bank</span>
                    </button>
                  </div>
                </div>

                {isOpenEditCashAccount && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                      {/* Modal Header */}
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Add New External Bank
                          </h2>
                          <div className="flex justify-end">
                            <img
                              onClick={togglePopupAddTransactionCashAccount}
                              src="/add.svg"
                              alt="Add"
                              className="w-10 h-10 cursor-pointer"
                            />
                          </div>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toAccountName}
                                onChange={(e) =>
                                  setToAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            {countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) && (
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountNumber}
                                    onChange={(e) =>
                                      setToAccountNumber(e.target.value)
                                    }
                                    className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="0291288"
                                  />
                                </div>
                              )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Bank Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBank}
                                onChange={(e) => setToBank(e.target.value)}
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Bank Name"
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Select Country"
                                options={countryCodeData}
                                search={true}
                                preselectedValue={preselectedCountryCode}
                                onSelect={handleSelectCountryCode}
                                colorLabel=""
                              />
                            </div>
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            {countryCode == "AU" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  BSB
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toBsb}
                                  maxLength={6}
                                  onChange={(e) =>
                                    handleBsbChange(e.target.value)
                                  }
                                  className={`${
                                    bsbError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000"
                                />
                                {bsbError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {bsbError}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Swift/BIC code
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={swiftCode}
                                onChange={handleSwiftChange}
                                className={`${
                                  swiftError && countryCode != "AU"
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && countryCode != "AU" && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
                            </div>
                            {countryCode == "US" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Routing Number (ABA)
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={routingNumber}
                                  maxLength={9}
                                  onChange={(e) =>
                                    handleRoutingChange(e.target.value)
                                  }
                                  className={`${
                                    routingError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000000"
                                />
                                {routingError && (
                                  <p className="text-red-600 text-sm mt-1">
                                    {routingError}
                                  </p>
                                )}
                              </div>
                            )}
                            {countryCode == "CA" && (
                              <>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transit Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={transitNumber}
                                    maxLength={5}
                                    onChange={(e) =>
                                      handleTransitChange(e.target.value)
                                    }
                                    className={`${
                                      transitError
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="00000"
                                  />
                                  {transitError && (
                                    <p className="text-red-600 text-xs mt-1">
                                      {transitError}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Institution Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={institutionNumber}
                                    onChange={(e) =>
                                      setinstitutionNumber(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="000000"
                                  />
                                </div>
                              </>
                            )}
                            {(countryCode == "AE" ||
                              countryCode == "GB" ||
                              isEuropeanCountry(countryCode)) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  IBAN
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={iban}
                                  onChange={handleChangeIban}
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                                {error && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {error}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 1
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine1}
                                onChange={(e) =>
                                  setAddressLine1(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Street address"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 2
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine2}
                                onChange={(e) =>
                                  setAddressLine2(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Apartment, unit etc."
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 3
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine3}
                                onChange={(e) =>
                                  setAddressLine3(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="City, Country etc."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={togglePopupAddTransactionCashAccount}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (countryCode == "AU" && (!toBsb || bsbError)) {
                                showToast("Please enter a valid BSB", "error");
                                return;
                              }
                              if (
                                countryCode == "US" &&
                                (!routingNumber || routingError)
                              ) {
                                showToast(
                                  "Please enter routing number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                (countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) &&
                                !iban
                              ) {
                                showToast("Please enter iban", "error");
                                return;
                              }
                              if (
                                countryCode == "CA" &&
                                (!transitNumber || transitError)
                              ) {
                                showToast(
                                  "Please enter a valid transit number",
                                  "error"
                                );
                                return;
                              }
                              if (countryCode == "CA" && !institutionNumber) {
                                showToast(
                                  "Please enter institution number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode != "AU" &&
                                (!swiftCode || swiftError)
                              ) {
                                showToast(
                                  "Please enter a valid swift code/BIC code",
                                  "error"
                                );
                                return;
                              }
                              if (error) {
                                showToast("Please enter valid iban", "error");
                                return;
                              }
                              if (
                                countryCode != "AE" &&
                                countryCode != "GB" &&
                                !isEuropeanCountry(countryCode) &&
                                !toAccountNumber
                              ) {
                                showToast(
                                  "Please enter account number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                !toAccountName ||
                                !toCurrency ||
                                !addressLine1 ||
                                !addressLine2 ||
                                !addressLine3 ||
                                !countryCode ||
                                !toBank
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleAddBank(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Add Bank
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {isModalOpenBankEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                      {/* Modal Header */}
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Edit External Bank
                          </h2>
                          <div className="flex justify-end">
                            <img
                              onClick={() => {
                                setcurrentBank(null);
                                setIsModalOpenBankEdit(false);
                              }}
                              src="/add.svg"
                              alt="Add"
                              className="w-10 h-10 cursor-pointer"
                            />
                          </div>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toAccountName}
                                onChange={(e) =>
                                  setToAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            {countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) && (
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountNumber}
                                    onChange={(e) =>
                                      setToAccountNumber(e.target.value)
                                    }
                                    className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="0291288"
                                  />
                                </div>
                              )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Bank Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBank}
                                onChange={(e) => setToBank(e.target.value)}
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Bank Name"
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Select Country"
                                options={countryCodeData}
                                search={true}
                                preselectedValue={preselectedCountryCode}
                                onSelect={handleSelectCountryCode}
                                colorLabel=""
                              />
                            </div>
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            {countryCode == "AU" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  BSB
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toBsb}
                                  maxLength={6}
                                  onChange={(e) =>
                                    handleBsbChange(e.target.value)
                                  }
                                  className={`${
                                    bsbError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000"
                                />
                                {bsbError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {bsbError}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Swift/BIC code
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={swiftCode}
                                onChange={handleSwiftChange}
                                className={`${
                                  swiftError && countryCode != "AU"
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && countryCode != "AU" && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
                            </div>
                            {countryCode == "US" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Routing Number (ABA)
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={routingNumber}
                                  maxLength={9}
                                  onChange={(e) =>
                                    handleRoutingChange(e.target.value)
                                  }
                                  className={`${
                                    routingError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000000"
                                />
                                {routingError && (
                                  <p className="text-red-600 text-sm mt-1">
                                    {routingError}
                                  </p>
                                )}
                              </div>
                            )}
                            {countryCode == "CA" && (
                              <>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transit Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={transitNumber}
                                    maxLength={5}
                                    onChange={(e) =>
                                      handleTransitChange(e.target.value)
                                    }
                                    className={`${
                                      transitError
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="00000"
                                  />
                                  {transitError && (
                                    <p className="text-red-600 text-xs mt-1">
                                      {transitError}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Institution Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={institutionNumber}
                                    onChange={(e) =>
                                      setinstitutionNumber(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="000000"
                                  />
                                </div>
                              </>
                            )}
                            {(countryCode == "AE" ||
                              countryCode == "GB" ||
                              isEuropeanCountry(countryCode)) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  IBAN
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={iban}
                                  onChange={handleChangeIban}
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                                {error && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {error}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 1
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine1}
                                onChange={(e) =>
                                  setAddressLine1(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Street address"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 2
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine2}
                                onChange={(e) =>
                                  setAddressLine2(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Apartment, unit etc."
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 3
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine3}
                                onChange={(e) =>
                                  setAddressLine3(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="City, Country etc."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={() => {
                              setcurrentBank(null);
                              setIsModalOpenBankEdit(false);
                            }}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (countryCode == "AU" && (!toBsb || bsbError)) {
                                showToast("Please enter a valid BSB", "error");
                                return;
                              }
                              if (
                                countryCode == "US" &&
                                (!routingNumber || routingError)
                              ) {
                                showToast(
                                  "Please enter routing number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                (countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) &&
                                !iban
                              ) {
                                showToast("Please enter iban", "error");
                                return;
                              }
                              if (
                                countryCode == "CA" &&
                                (!transitNumber || transitError)
                              ) {
                                showToast(
                                  "Please enter a valid transit number",
                                  "error"
                                );
                                return;
                              }
                              if (countryCode == "CA" && !institutionNumber) {
                                showToast(
                                  "Please enter institution number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode != "AU" &&
                                (!swiftCode || swiftError)
                              ) {
                                showToast(
                                  "Please enter a valid swift code/BIC code",
                                  "error"
                                );
                                return;
                              }
                              if (error) {
                                showToast("Please enter valid iban", "error");
                                return;
                              }
                              if (
                                countryCode != "AE" &&
                                countryCode != "GB" &&
                                !isEuropeanCountry(countryCode) &&
                                !toAccountNumber
                              ) {
                                showToast(
                                  "Please enter account number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                !toAccountName ||
                                !toCurrency ||
                                !addressLine1 ||
                                !addressLine2 ||
                                !addressLine3 ||
                                !countryCode ||
                                !toBank
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleEditBank(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Edit Bank
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Profile Section */}
                <div className="p-4">
                  {/* Filters Section */}
                  <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleshowRecord}
                        />
                      </div>
                    </div>
                    <div className="flex md:flex-row flex-col items-center md:space-x-4">
                      {thirdPartyFilterTab === "allThp" && (
                        <div
                          ref={StatusRef}
                          className="relative w-full md:w-full"
                        >
                          {/* Dropdown Button */}
                          <button
                            onClick={() => setIsStatusOpen(!isStatusOpen)}
                            className={`w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-3 py-2 flex items-center focus:outline-none ${
                              isStatusOpen
                                ? "bg-black text-white"
                                : "bg-white text-black"
                            }`}
                          >
                            {/* Left Icon */}
                            <img
                              src={
                                isStatusOpen
                                  ? "/filter-sort-white.svg"
                                  : "/filter-sort-black.svg"
                              }
                              alt="Filter Icon"
                              className="h-5 w-5 mr-2"
                            />

                            {/* Text (pushes dropdown icon to the right) */}
                            <span className="flex-1">Filter Status</span>

                            {/* Right Dropdown Icon */}
                            <img
                              src={
                                isStatusOpen
                                  ? "/chevron-down.svg"
                                  : "/chevron-down-black.svg"
                              }
                              alt="Dropdown Icon"
                              className="h-5 w-5 flex-shrink-0 ml-auto transition-transform duration-300 transform"
                            />
                          </button>

                          {/* Dropdown List */}
                          {isStatusOpen && (
                            <div
                              className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-[999]"
                              style={{
                                maxHeight: "200px", // Optional: limit height
                              }}
                            >
                              {AllStatusFilters.map((option) => (
                                <div
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleSelectStatus(option);
                                  }}
                                  key={option.value}
                                  className={`px-4 py-2 flex items-center hover:bg-black hover:text-white cursor-pointer ${
                                    option.value == selectedStatus
                                      ? " bg-black text-white"
                                      : ""
                                  }`}
                                >
                                  {option.label}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Table */}

                  <div className="overflow-x-auto">
                    <table className="w-full h-full  border-separate pb-4 border-[#EDEDED]  border-spacing-y-2">
                      <thead className="text-[#8C8C8C] text-sm">
                        <tr className="border border-[#EDEDED]">
                          {withOutheadersRequestDashboard.map(
                            (header, index) => (
                              <th
                                key={header.label}
                                className={`
                               cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-center
                               ${
                                 index === 0
                                   ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                                   : ""
                               }
                                   ${
                                     index === 1 ||
                                     index === 2 ||
                                     index === 3 ||
                                     index === 4 ||
                                     index === 5 ||
                                     index === 6 ||
                                     index === 7 ||
                                     index === 8 ||
                                     index === 9
                                       ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                       : ""
                                   }
                                 ${
                                   index === 10
                                     ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                                     : ""
                                 }
                             `}
                              >
                                <div class="flex items-center">
                                  <span>{header.label}</span>
                                </div>
                              </th>
                            )
                          )}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(3)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(8)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm font-medium text-black">
                          {transactionTableData.length > 0 ? (
                            transactionTableData.map((row, index) => (
                              <React.Fragment key={index}>
                                <tr
                                  className={`cursor-pointer mb-2 bg-[#F9F9F9]`}
                                >
                                  <td className="px-4 py-2">
                                    <div className="flex items-center space-x-2">
                                      <img
                                        src="/clock.svg"
                                        alt="Time Icon"
                                        className="h-4 w-4"
                                      />
                                      <span className="rounded-xl">
                                        {`${formatDateList(row.created_at)}`}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_name}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_number == null
                                      ? row.iban
                                      : row.account_number}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_bsb}
                                  </td>
                                  <td className="px-4 py-2">{row.bank_name}</td>
                                  <td className="px-4 py-2 space-y-1">
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Swift Code:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.swift_code ?? "N/A"}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Institution Number:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.institution_number ?? "N/A"}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Transit Number:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.transit_number ?? "N/A"}
                                      </span>
                                    </p>
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.address_line1}-{row.address_line2}
                                    {row.address_line3
                                      ? "-" + row.address_line3
                                      : ""}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.country_code}
                                  </td>
                                  <td className="px-4 py-2 relative">
                                    <button
                                      ref={(el) =>
                                        (buttonRefs.current[`${row.id}`] = el)
                                      }
                                      disabled={
                                        row.status == "pending" ? false : true
                                      }
                                      onClick={() =>
                                        handleDropdownToggle(row.id)
                                      }
                                      className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                        row.status == "pending"
                                          ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                          : ""
                                      }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                              ${
                                row.status == "rejected"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                                    >
                                      <span className="mr-6">
                                        {" "}
                                        {row.status == "pending"
                                          ? "Pending"
                                          : row.status.charAt(0).toUpperCase() +
                                            row.status.slice(1)}
                                      </span>
                                      {row.status == "pending" && (
                                        <img
                                          src={`${
                                            openDropdown === row.id
                                              ? "/Vector.svg"
                                              : "/down-grey.svg"
                                          }`}
                                          alt="Selected"
                                          className="w-3 h-3 ml-4"
                                        />
                                      )}
                                    </button>
                                    <DropdownTest
                                      isOpen={openDropdown === row.id}
                                      buttonRef={
                                        buttonRefs.current[`${row.id}`]
                                      } // Pass unique ref to the dropdown
                                    >
                                      <div
                                        ref={dropdownRef}
                                        className="absolute left-0 bg-white rounded-md shadow-lg overflow-hidden z-50 w-full max-w-[200px] border"
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                        }}
                                      >
                                        {AllStatus.map((option) => (
                                          <div
                                            key={option.value}
                                            onClick={(e) => {
                                              setLoading(true);
                                              handleStatusChange(
                                                e,
                                                option,
                                                row.id
                                              );
                                            }}
                                            className={`px-4 py-2 p-3 w-30 mx-2 my-1 text-sm cursor-pointer flex items-center justify-between rounded-xl ${
                                              option.value === "approved"
                                                ? "border-2 border-[#34C046] text-[#34C046] bg-[#93DB9C] hover:bg-[#34C046] hover:text-white"
                                                : "border-2 border-[#FF5050] text-[#FF5050] bg-[#E9BDBD] hover:bg-[#FF5050] hover:text-white"
                                            }`}
                                          >
                                            <span>{option.label}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </DropdownTest>
                                  </td>
                                  <td
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleFileClick(e, row);
                                    }}
                                    className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap"
                                  >
                                    <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                                      View Uploaded Image
                                    </span>
                                  </td>
                                  <td
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleEditClick(e, row);
                                    }}
                                    className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap"
                                  >
                                    <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                                      Edit Details
                                    </span>
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center py-4" colSpan="7">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                  {isModalOpen && currentDocument && (
                    <DocumentPreview
                      fileUrl={currentDocument.proof_image_url}
                      fileName={currentDocument.proof_image_name}
                      onClose={() => setIsModalOpen(false)}
                    />
                  )}
                  {transactionTableData != null && (
                    <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                      {/* Entries Info Section */}
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing {showRecords * (currentPage - 1) + 1} to{" "}
                        {currentPage === totalPages || totalPages == 0
                          ? totalCount
                          : Math.max(
                              showRecords * currentPage,
                              transactionTableData.length
                            )}{" "}
                        of {totalCount} entries
                      </div>

                      {/* Pagination Section */}
                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        {/* Previous Button */}
                        <button
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>

                        {/* Page Buttons */}
                        {Array.from({ length: Math.min(totalPages, 5) }).map(
                          (_, index) => {
                            const startPage = Math.max(
                              1,
                              Math.min(totalPages - 4, currentPage - 2)
                            );
                            const page = startPage + index;

                            return (
                              <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-3 py-1 rounded ${
                                  currentPage === page
                                    ? "bg-black text-white"
                                    : "bg-white border border-gray-300 text-black"
                                }`}
                              >
                                {page}
                              </button>
                            );
                          }
                        )}

                        {/* Next Button */}
                        <button
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
          {bankTab === "thpBank" && (
            <>
              <div className="pt-2 text-xs overflow-x-auto flex-wrap items-center">
                <div className="flex mb-2 relative">
                  <button
                    onClick={() => {
                      setThirdPartyFilterTab("allThp");
                      setSelectedStatus(null);
                      resetAllThpFilters();
                    }}
                    className={`px-4 py-2 rounded-l-xl border-r border-gray-100 ${
                      thirdPartyFilterTab === "allThp"
                        ? "bg-black text-white"
                        : "bg-white text-black"
                    }`}
                  >
                    All Third Party Accounts
                  </button>

                  <div className="relative">
                    <button
                      onClick={() => {
                        setThirdPartyFilterTab("reqThp");
                        setSelectedStatus("pending");
                        resetAllThpFilters();
                      }}
                      className={`lg:px-4 px-2 py-2 rounded-r-xl relative ${
                        thirdPartyFilterTab === "reqThp"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      Requests
                      {totalPendingExternalBank > 0 && (
                        <span className="absolute -top-2 right-0  -right-2 bg-red-500 text-white text-[10px] text-xs font-bold px-1.5 lg:px-2 py-0.5 rounded-full flex items-center justify-center min-w-[16px] lg:min-w-[18px]">
                          {totalPendingExternalBank > 99
                            ? "99+"
                            : totalPendingExternalBank}
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-full p-4 bg-white rounded-lg shadow-lg">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b pb-5 border-gray-100">
                  {/* Left: Title */}
                  <div className="flex items-center">
                    <img
                      src="/cards.svg"
                      alt="Company Logo"
                      className="mr-2 w-6 h-6"
                    />
                    <span className="font-medium lg:text-xl text-sm">
                      Third Party Bank Accounts
                    </span>
                  </div>

                  {/* Right: Count and Button */}
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full md:w-auto justify-end">
                    <p className="text-sm">
                      <span className="font-medium text-labelLightColour">
                        No of Bank Accounts:{" "}
                      </span>
                      <span className="font-medium text-black">
                        {totalCountExternalBank}
                      </span>
                    </p>
                    <button
                      onClick={() => {
                        togglePopupAddBankCashAccount();
                      }}
                      className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                    >
                      <img
                        src="/Plus.svg"
                        alt="Add Icon"
                        className="mr-2 ml-2"
                      />
                      <span className="inline">Add Bank</span>
                    </button>
                  </div>
                </div>

                {isOpenEditCashAccountBank && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                      {/* Modal Header */}
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Add New Third Party Bank
                          </h2>
                          <div className="flex justify-end">
                            <img
                              onClick={togglePopupAddBankCashAccount}
                              src="/add.svg"
                              alt="Add"
                              className="w-10 h-10 cursor-pointer"
                            />
                          </div>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toAccountName}
                                onChange={(e) =>
                                  setToAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            {countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) && (
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountNumber}
                                    onChange={(e) =>
                                      setToAccountNumber(e.target.value)
                                    }
                                    className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="0291288"
                                  />
                                </div>
                              )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Bank Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBank}
                                onChange={(e) => setToBank(e.target.value)}
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Bank Name"
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Select Country"
                                options={countryCodeData}
                                search={true}
                                preselectedValue={preselectedCountryCode}
                                onSelect={handleSelectCountryCode}
                                colorLabel=""
                              />
                            </div>
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            {countryCode == "AU" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  BSB
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toBsb}
                                  maxLength={6}
                                  onChange={(e) =>
                                    handleBsbChange(e.target.value)
                                  }
                                  className={`${
                                    bsbError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000"
                                />
                                {bsbError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {bsbError}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Swift/BIC code
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={swiftCode}
                                onChange={handleSwiftChange}
                                className={`${
                                  swiftError && countryCode != "AU"
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && countryCode != "AU" && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
                            </div>
                            {countryCode == "US" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Routing Number (ABA)
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={routingNumber}
                                  maxLength={9}
                                  onChange={(e) =>
                                    handleRoutingChange(e.target.value)
                                  }
                                  className={`${
                                    routingError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000000"
                                />
                                {routingError && (
                                  <p className="text-red-600 text-sm mt-1">
                                    {routingError}
                                  </p>
                                )}
                              </div>
                            )}
                            {countryCode == "CA" && (
                              <>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transit Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={transitNumber}
                                    maxLength={5}
                                    onChange={(e) =>
                                      handleTransitChange(e.target.value)
                                    }
                                    className={`${
                                      transitError
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="00000"
                                  />
                                  {transitError && (
                                    <p className="text-red-600 text-xs mt-1">
                                      {transitError}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Institution Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={institutionNumber}
                                    onChange={(e) =>
                                      setinstitutionNumber(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="000000"
                                  />
                                </div>
                              </>
                            )}
                            {(countryCode == "AE" ||
                              countryCode == "GB" ||
                              isEuropeanCountry(countryCode)) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  IBAN
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={iban}
                                  onChange={handleChangeIban}
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                                {error && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {error}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 1
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine1}
                                onChange={(e) =>
                                  setAddressLine1(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Street address"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 2
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine2}
                                onChange={(e) =>
                                  setAddressLine2(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Apartment, unit etc."
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 3
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine3}
                                onChange={(e) =>
                                  setAddressLine3(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="City, Country etc."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={togglePopupAddBankCashAccount}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (countryCode == "AU" && (!toBsb || bsbError)) {
                                showToast("Please enter a valid BSB", "error");
                                return;
                              }
                              if (
                                countryCode == "US" &&
                                (!routingNumber || routingError)
                              ) {
                                showToast(
                                  "Please enter routing number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                (countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) &&
                                !iban
                              ) {
                                showToast("Please enter iban", "error");
                                return;
                              }
                              if (error) {
                                showToast("Please enter valid iban", "error");
                                return;
                              }
                              if (
                                countryCode != "AE" &&
                                countryCode != "GB" &&
                                !isEuropeanCountry(countryCode) &&
                                !toAccountNumber
                              ) {
                                showToast(
                                  "Please enter account number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode == "CA" &&
                                (!transitNumber || transitError)
                              ) {
                                showToast(
                                  "Please enter a valid transit number",
                                  "error"
                                );
                                return;
                              }
                              if (countryCode == "CA" && !institutionNumber) {
                                showToast(
                                  "Please enter institution number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode != "AU" &&
                                (!swiftCode || swiftError)
                              ) {
                                showToast(
                                  "Please enter a valid swift code/BIC code",
                                  "error"
                                );
                                return;
                              }
                              if (
                                !toAccountName ||
                                !toCurrency ||
                                !addressLine1 ||
                                !addressLine2 ||
                                !addressLine3 ||
                                !countryCode ||
                                !toBank
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleThirdPartyBank(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Add Bank
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Profile Section */}
                <div className="p-4">
                  {/* Filters Section */}
                  <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleshowRecordBank}
                        />
                      </div>
                    </div>
                    <div className="flex md:flex-row flex-col items-center md:space-x-4">
                      {thirdPartyFilterTab === "allThp" && (
                        <div
                          ref={StatusRef}
                          className="relative w-full md:w-full"
                        >
                          {/* Dropdown Button */}
                          <button
                            onClick={() => setIsStatusOpen(!isStatusOpen)}
                            className={`w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-3 py-2 flex items-center focus:outline-none ${
                              isStatusOpen
                                ? "bg-black text-white"
                                : "bg-white text-black"
                            }`}
                          >
                            {/* Left Icon */}
                            <img
                              src={
                                isStatusOpen
                                  ? "/filter-sort-white.svg"
                                  : "/filter-sort-black.svg"
                              }
                              alt="Filter Icon"
                              className="h-5 w-5 mr-2"
                            />

                            {/* Text (pushes dropdown icon to the right) */}
                            <span className="flex-1">Filter Status</span>

                            {/* Right Dropdown Icon */}
                            <img
                              src={
                                isStatusOpen
                                  ? "/chevron-down.svg"
                                  : "/chevron-down-black.svg"
                              }
                              alt="Dropdown Icon"
                              className="h-5 w-5 flex-shrink-0 ml-auto transition-transform duration-300 transform"
                            />
                          </button>

                          {/* Dropdown List */}
                          {isStatusOpen && (
                            <div
                              className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-[999]"
                              style={{
                                maxHeight: "200px", // Optional: limit height
                              }}
                            >
                              {AllStatusFilters.map((option) => (
                                <div
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleSelectStatus(option);
                                  }}
                                  key={option.value}
                                  className={`px-4 py-2 flex items-center hover:bg-black hover:text-white cursor-pointer ${
                                    option.value == selectedStatus
                                      ? " bg-black text-white"
                                      : ""
                                  }`}
                                >
                                  {option.label}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Table */}

                  <div className="overflow-x-auto">
                    <table className="w-full h-full  border-separate pb-4 border-[#EDEDED]  border-spacing-y-2">
                      <thead className="text-[#8C8C8C] text-sm">
                        <tr className="border border-[#EDEDED]">
                          {externalAccountHeaders.map((header, index) => (
                            <th
                              key={header.label}
                              className={`
                                                   cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-center
                                                   ${
                                                     index === 0
                                                       ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                                                       : ""
                                                   }
                                                       ${
                                                         index === 1 ||
                                                         index === 2 ||
                                                         index === 3 ||
                                                         index === 4 ||
                                                         index === 5 ||
                                                         index === 6 ||
                                                         index === 7 ||
                                                         index === 8
                                                           ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                                           : ""
                                                       }
                                                     ${
                                                       index === 9
                                                         ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                                                         : ""
                                                     }
                                                 `}
                            >
                              <div class="flex items-center">
                                <span>{header.label}</span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(3)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(8)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm font-medium text-black">
                          {externalbankTable.length > 0 ? (
                            externalbankTable.map((row, index) => (
                              <React.Fragment key={index}>
                                <tr
                                  className={`cursor-pointer mb-2 bg-[#F9F9F9]`}
                                >
                                  <td className="px-4 py-2">
                                    <div className="flex items-center space-x-2">
                                      <img
                                        src="/clock.svg"
                                        alt="Time Icon"
                                        className="h-4 w-4"
                                      />
                                      <span className="rounded-xl">
                                        {`${formatDateList(row.created_at)}`}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_name}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_number}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_bsb}
                                  </td>
                                  <td className="px-4 py-2">{row.bank_name}</td>
                                  <td className="px-4 py-2 space-y-1">
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Swift Code:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.swift_code ?? "N/A"}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Institution Number:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.institution_number ?? "N/A"}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Transit Number:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.transit_number ?? "N/A"}
                                      </span>
                                    </p>
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.address_line1}-{row.address_line2}
                                    {row.address_line3
                                      ? "-" + row.address_line3
                                      : ""}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.country_code}
                                  </td>
                                  <td className="px-4 py-2 relative">
                                    <button
                                      onClick={() =>
                                        handleDropdownToggleExternalbank(row.id)
                                      }
                                      ref={(el) =>
                                        (buttonRefs.current[`${row.id}`] = el)
                                      }
                                      disabled={
                                        row.status == "pending" ? false : true
                                      }
                                      className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                        row.status == "pending"
                                          ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                          : ""
                                      }
                                                  ${
                                                    row.status == "approved"
                                                      ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                                      : ""
                                                  }
                                                  ${
                                                    row.status == "rejected"
                                                      ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                                      : ""
                                                  }
                                                  `}
                                    >
                                      <span className="mr-6">
                                        {" "}
                                        {row.status == "pending"
                                          ? "Pending"
                                          : row.status.charAt(0).toUpperCase() +
                                            row.status.slice(1)}
                                      </span>
                                      {row.status == "pending" && (
                                        <img
                                          src={`${
                                            openDropdown === row.id
                                              ? "/Vector.svg"
                                              : "/down-grey.svg"
                                          }`}
                                          alt="Selected"
                                          className="w-3 h-3 ml-4"
                                        />
                                      )}
                                    </button>
                                    <DropdownTest
                                      isOpen={openDropdown === row.id}
                                      buttonRef={
                                        buttonRefs.current[`${row.id}`]
                                      } // Pass unique ref to the dropdown
                                    >
                                      <div
                                        ref={dropdownRef}
                                        className="absolute left-0 bg-white rounded-md shadow-lg overflow-hidden z-50 w-full max-w-[200px] border"
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                        }}
                                      >
                                        {AllStatusExternal.map((option) => (
                                          <div
                                            key={option.value}
                                            onClick={(e) => {
                                              setLoading(true);
                                              handleStatusChangeBank(
                                                e,
                                                option,
                                                row.id
                                              );
                                            }}
                                            className={`px-4 py-2 p-3 w-30 mx-2 my-1 text-sm cursor-pointer flex items-center justify-between rounded-xl ${
                                              option.value === "approved"
                                                ? "border-2 border-[#34C046] text-[#34C046] bg-[#93DB9C] hover:bg-[#34C046] hover:text-white"
                                                : "border-2 border-[#FF5050] text-[#FF5050] bg-[#E9BDBD] hover:bg-[#FF5050] hover:text-white"
                                            }`}
                                          >
                                            <span>{option.label}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </DropdownTest>
                                  </td>
                                  <td
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleEditClickBank(e, row);
                                    }}
                                    className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap"
                                  >
                                    <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                                      Edit Details
                                    </span>
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center py-4" colSpan="7">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                  {externalbankTable != null && (
                    <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                      {/* Entries Info Section */}
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing{" "}
                        {showRecordsExternalBank *
                          (currentPageExternalBank - 1) +
                          1}{" "}
                        to{" "}
                        {currentPageExternalBank === totalPagesExternalBank ||
                        totalPagesExternalBank == 0
                          ? totalCountExternalBank
                          : Math.max(
                              showRecordsExternalBank * currentPageExternalBank,
                              externalbankTable.length
                            )}{" "}
                        of {totalCountExternalBank} entries
                      </div>

                      {/* Pagination Section */}
                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        {/* Previous Button */}
                        <button
                          disabled={currentPageExternalBank === 1}
                          onClick={() =>
                            setCurrentPageExternalBank((prev) => prev - 1)
                          }
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>

                        {/* Page Buttons */}
                        {Array.from({
                          length: Math.min(totalPagesExternalBank, 5),
                        }).map((_, index) => {
                          const startPage = Math.max(
                            1,
                            Math.min(
                              totalPagesExternalBank - 4,
                              currentPageExternalBank - 2
                            )
                          );
                          const page = startPage + index;

                          return (
                            <button
                              key={page}
                              onClick={() => setCurrentPageExternalBank(page)}
                              className={`px-3 py-1 rounded ${
                                currentPageExternalBank === page
                                  ? "bg-black text-white"
                                  : "bg-white border border-gray-300 text-black"
                              }`}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {/* Next Button */}
                        <button
                          disabled={
                            currentPageExternalBank === totalPagesExternalBank
                          }
                          onClick={() =>
                            setCurrentPageExternalBank((prev) => prev + 1)
                          }
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {isModalOpenBankEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                      {/* Modal Header */}
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Edit External Bank
                          </h2>
                          <div className="flex justify-end">
                            <img
                              onClick={() => {
                                setcurrentBank(null);
                                setIsModalOpenBankEdit(false);
                              }}
                              src="/add.svg"
                              alt="Add"
                              className="w-10 h-10 cursor-pointer"
                            />
                          </div>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toAccountName}
                                onChange={(e) =>
                                  setToAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            {countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) && (
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountNumber}
                                    onChange={(e) =>
                                      setToAccountNumber(e.target.value)
                                    }
                                    className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="0291288"
                                  />
                                </div>
                              )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Bank Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBank}
                                onChange={(e) => setToBank(e.target.value)}
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Bank Name"
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Select Country"
                                options={countryCodeData}
                                search={true}
                                preselectedValue={preselectedCountryCode}
                                onSelect={handleSelectCountryCode}
                                colorLabel=""
                              />
                            </div>
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            {countryCode == "AU" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  BSB
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toBsb}
                                  maxLength={6}
                                  onChange={(e) =>
                                    handleBsbChange(e.target.value)
                                  }
                                  className={`${
                                    bsbError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000"
                                />
                                {bsbError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {bsbError}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Swift/BIC code
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={swiftCode}
                                onChange={handleSwiftChange}
                                className={`${
                                  swiftError && countryCode != "AU"
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && countryCode != "AU" && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
                            </div>
                            {countryCode == "US" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Routing Number (ABA)
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={routingNumber}
                                  maxLength={9}
                                  onChange={(e) =>
                                    handleRoutingChange(e.target.value)
                                  }
                                  className={`${
                                    routingError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000000"
                                />
                                {routingError && (
                                  <p className="text-red-600 text-sm mt-1">
                                    {routingError}
                                  </p>
                                )}
                              </div>
                            )}
                            {countryCode == "CA" && (
                              <>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transit Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={transitNumber}
                                    maxLength={5}
                                    onChange={(e) =>
                                      handleTransitChange(e.target.value)
                                    }
                                    className={`${
                                      transitError
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="00000"
                                  />
                                  {transitError && (
                                    <p className="text-red-600 text-xs mt-1">
                                      {transitError}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Institution Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={institutionNumber}
                                    onChange={(e) =>
                                      setinstitutionNumber(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="000000"
                                  />
                                </div>
                              </>
                            )}
                            {(countryCode == "AE" ||
                              countryCode == "GB" ||
                              isEuropeanCountry(countryCode)) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  IBAN
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={iban}
                                  onChange={handleChangeIban}
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                                {error && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {error}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 1
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine1}
                                onChange={(e) =>
                                  setAddressLine1(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Street address"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 2
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine2}
                                onChange={(e) =>
                                  setAddressLine2(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Apartment, unit etc."
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 3
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine3}
                                onChange={(e) =>
                                  setAddressLine3(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="City, Country etc."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={() => {
                              setcurrentBank(null);
                              setIsModalOpenBankEdit(false);
                            }}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (countryCode == "AU" && (!toBsb || bsbError)) {
                                showToast("Please enter a valid BSB", "error");
                                return;
                              }
                              if (
                                countryCode == "US" &&
                                (!routingNumber || routingError)
                              ) {
                                showToast(
                                  "Please enter routing number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                (countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) &&
                                !iban
                              ) {
                                showToast("Please enter iban", "error");
                                return;
                              }
                              if (
                                countryCode == "CA" &&
                                (!transitNumber || transitError)
                              ) {
                                showToast(
                                  "Please enter a valid transit number",
                                  "error"
                                );
                                return;
                              }
                              if (countryCode == "CA" && !institutionNumber) {
                                showToast(
                                  "Please enter institution number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode != "AU" &&
                                (!swiftCode || swiftError)
                              ) {
                                showToast(
                                  "Please enter a valid swift code/BIC code",
                                  "error"
                                );
                                return;
                              }
                              if (error) {
                                showToast("Please enter valid iban", "error");
                                return;
                              }
                              if (
                                countryCode != "AE" &&
                                countryCode != "GB" &&
                                !isEuropeanCountry(countryCode) &&
                                !toAccountNumber
                              ) {
                                showToast(
                                  "Please enter account number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                !toAccountName ||
                                !toCurrency ||
                                !addressLine1 ||
                                !addressLine2 ||
                                !addressLine3 ||
                                !countryCode ||
                                !toBank
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleEditBank(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Edit Bank
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}
      {filter == "accounts" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          {!cardActivated && (
            <>
              <div className="w-full p-4 bg-white rounded-lg shadow-lg">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
                  <div className="flex items-center mb-2 md:mb-0">
                    <img
                      src="/card-tick.svg"
                      alt="Company Logo"
                      className="mr-3 w-6 h-6"
                    />
                    <span className="font-medium lg:text-xl text-sm">
                      Active Accounts
                    </span>
                  </div>
                  <p className="text-sm">
                    <span className="font-medium text-labelLightColour">
                      No of Active Accounts:{" "}
                    </span>
                    <span className="font-medium text-black">
                      {accountdata.no_of_active_accounts}
                    </span>
                  </p>
                </div>

                {/* Profile Section */}
                <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                  {/* Profile Details */}
                  <div className="grid border-b  grid-cols-1 sm:grid-cols-2 md:grid-cols-4 md:gap-6 gap-2 w-full ">
                    {/* Column 1 */}
                    <div className="flex flex-col md:px-4 md:pt-6">
                      <div className="flex flex-col  bg-[#5D88F8] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          Cash Account
                        </label>
                        <span className="text-sm font-semibold">
                          $
                          {accountdata.active_accounts?.total_cashaccounts
                            ? accountdata.active_accounts.total_cashaccounts.toFixed(
                                2
                              )
                            : "0.00"}
                        </span>
                      </div>
                      <div className="flex flex-col mt-4 mb-4 bg-[#996EE7] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          Fund Management
                        </label>
                        <span className="text-sm font-semibold">
                          $
                          {accountdata.active_accounts?.no_of_fund_accounts
                            ? accountdata.active_accounts.no_of_fund_accounts.toFixed(
                                2
                              )
                            : "0.00"}
                        </span>
                      </div>
                    </div>

                    {/* Column 2 */}
                    <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                      <div className="flex flex-col  bg-[#F18C29] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          Securities
                        </label>
                        <span className="text-sm font-semibold">
                          $
                          {accountdata.active_accounts?.securities
                            ? accountdata.active_accounts.securities.toFixed(2)
                            : "0.00"}
                        </span>
                      </div>

                      <div className="flex flex-col mt-4 md:mb-4 bg-[#DC4646] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          Trading
                        </label>
                        <span className="text-sm font-semibold">
                          $
                          {accountdata.active_accounts?.trading
                            ? accountdata.active_accounts.trading.toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                      <div className="flex flex-col  bg-[#2DB0EC] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          Custodian
                        </label>
                        <span className="text-sm font-semibold">
                          $
                          {accountdata.active_accounts?.custodian
                            ? accountdata.active_accounts.custodian.toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                      <div className="flex flex-col mt-4 mb-4 bg-[#6B68F2] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          My Investment
                        </label>
                        <span className="text-sm font-semibold">
                          $
                          {accountdata.active_accounts?.investment
                            ? accountdata.active_accounts.investment.toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                      <div className="flex flex-col  bg-[#34C046] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          Digital Assets{" "}
                        </label>
                        <span className="text-sm font-semibold">
                          $
                          {accountdata.active_accounts?.asset
                            ? accountdata.active_accounts.asset.toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full p-4 bg-white rounded-lg mt-4 shadow-lg">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
                  <div className="flex items-center mb-2 md:mb-0">
                    <img
                      src="/card-tick.svg"
                      alt="Company Logo"
                      className="mr-3 w-6 h-6"
                    />
                    <span className="font-medium lg:text-xl text-sm">
                      Archived Accounts
                    </span>
                  </div>
                  <p className="text-sm">
                    <span className="font-medium text-labelLightColour">
                      No of Archived Accounts:{" "}
                    </span>
                    <span className="font-medium text-black">
                      {accountdata.no_of_archieved_accounts}
                    </span>
                  </p>
                </div>

                {/* Profile Section */}
                <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                  {/* Profile Details */}
                  <div className="grid border-b  grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                    {/* Column 1 */}
                    <div className="flex flex-col md:px-4 md:pt-6">
                      <div className="flex flex-col  bg-[#5D88F8] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          Cash Account
                        </label>
                        <span className="text-sm font-semibold">
                          {" "}
                          $
                          {accountdata.archieved_accounts?.no_of_cash_accounts
                            ? accountdata.archieved_accounts.no_of_cash_accounts.toFixed(
                                2
                              )
                            : "0.00"}
                        </span>
                      </div>
                      <div className="flex flex-col mt-4 mb-4 bg-[#996EE7] px-3 py-2 rounded-xl bg-opacity-50">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-white font-semibold"
                        >
                          Fund Management
                        </label>
                        <span className="text-sm font-semibold">
                          $
                          {accountdata.archieved_accounts?.no_of_fund_accounts
                            ? accountdata.archieved_accounts.no_of_fund_accounts.toFixed(
                                2
                              )
                            : "0.00"}
                        </span>
                      </div>
                    </div>

                    {/* Column 2 */}
                    <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l"></div>

                    {/* Column 3 */}
                    <div className="flex flex-col md:px-4 md:pt-6 md:border-l"></div>
                    <div className="flex flex-col md:px-4 md:pt-6 md:border-l"></div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomerDetails;
